import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import moment from "moment";
import axios from "axios";

import { Button, Checkbox, Label, Modal } from "react-bootstrap";
import Datetime from "react-datetime";
import Formsy from "formsy-react";

import { assignDistributor, cancelOrderByApi, restoreOrderByApi, updateOrderByApi } from "../../orders/orders.actions";
import { cancelBookedOrderByApi } from "../../BookedOrders/bookedOrders.actions";
import { getNewDistributorList } from "../../Admin/admin.actions";
import {
    closeOrderDetails,
    deliverOrder,
    deliverPickUpOrder,
    divideOrder,
    divideOrderAuto,
    getRestaurantsByIDs,
    getShopsForMergeOrder,
    openOrderDetails,
    reverseGeocode,
    searchAddress,
    sendToPartner,
    updateProduct,
    updateShopState,
} from "../orderDetails.actions";

import translator from "../../../components/localization/translator";
import rolesConf from "../../../config/roles";
import { BASE_URL } from "../../../config";

import {
    BOOKED_SERVICE_STATUSES,
    CANCEL_REASONS,
    COMPARATIONS,
    DEFAULT_DELIVERY_PRICE,
    DELIVERY_PRICE_CHANGE_REASONS,
    DELIVERY_PRICE_OTHER_MAX_LENGTH,
    DELIVERY_PRICE_OTHER_REASON,
    DELIVERY_PRICE_REASON_LABEL,
    ENTER_KEY, ERRORS,
    GIFT_CARD_SHOP_ID,
    GIFT_CARD_SHOP_NAME,
    GIFT_CARD_STATUSES,
    MAP_DEFAULT_VIEWPORT,
    NOTIFICATION_TYPES,
    OK_TELL_URL,
    ORDER_DETAILS_MODE,
    ORDER_SERVICE_STATUSES,
    ORDER_STATUSES as ORDER_STATUS,
    ORDER_STATUSES,
    PAYMENT_TYPES,
    RESTAURANT_TYPES,
    SALARY_TYPES_ENUM,
    USER_ROLES,
    WALLET_TYPES,
} from "../../../config/constants";
import DistributorList from "./DistributorList";
import ReceiverMap from "../../../components/maps/ReceiverMap";
import CollapseList from "./CollapseList";
import FooterButtons from "../../../components/common/elements/FooterButtons";
import security from "../../../components/common/security/security";
import FormInput from "../../../components/common/elements/FormInput";
import InputWithLabel from "../../../components/common/elements/InputWithLabel";
import TextareaWithLabel from "../../../components/common/elements/TextareaWithLabel";
import RadioGroup from "../../../components/common/elements/RadioGroup";
import ToggleWithLabel from "../../../components/common/elements/ToggleWithLabel";
import { getDistributor } from "../../../components/distributors/distributors.utils";
import { getVehicleLetter } from "../../../config/distributorVehicleConstants";
import ShopList from "./ShopList";
import SelectShopsForMergeModal from "./SelectShopsForMergeModal";
import { PaymentDetails } from "./PaymentDetails/PaymentDetails";
import Notifier from "../../../components/message/Notifier";
import EditableFields from "./editableFields";
import { calculateActualAmount, redirectToOkTellTab } from "../../../lib/utils";
import "./OrderDetails.css";
import ReactTags from "react-tag-autocomplete";

const defaultViewport = [MAP_DEFAULT_VIEWPORT.lat, MAP_DEFAULT_VIEWPORT.lng];

const getInitialDeliveryPriceReasonState = () => ({
    deliveryPriceReason: "",
    deliveryPriceOtherDraft: "",
    deliveryPriceOtherSaved: "",
    isDeliveryPriceUnlocked: false,
});

class OrderDetails extends Component {
    constructor(props) {
        super(props);
        this.canBeChanged = true;
        const orderDetails = JSON.parse(JSON.stringify(props.orderDetails));
        const originalOrderShops = this.getOriginalOrderShops(props.orderDetails);

        this.state = {
            totalShopsPrice: 0,
            totalPaidAmount: 0,
            canSave: true,
            orderMode: ORDER_DETAILS_MODE.MODES.edit_mode,
            showPaymentDetails: false,
            isOtherReason: false,
            comment: "",
            cancelReason: CANCEL_REASONS.CUSTOMER_DUPLICATE.id,
            deliveryTime: "",
            invalidDate: false,
            toggleActive: false,
            suggestions: [],
            shops: [],
            originalOrderShops,
            giftCardsCount: 0,
            showMap: false,
            center: defaultViewport,
            zoom: 17,
            openAutoCompleteSelect: false,
            selectedShops: [],
            orderDetails,
            addressSuggestions: [],
            addressSuggestionsLoading: false,
            showAddressSuggestions: false,
            ...getInitialDeliveryPriceReasonState(),
            exportingProductsCsv: false,
        };

        this.role = security.getUser().role;
        this.editableFields = rolesConf.order.edit[this.role] || [];
        this.save = this.save.bind(this);
        this.renderShopList = this.renderShopList.bind(this);
        this.renderRadioGroup = this.renderRadioGroup.bind(this);
        this.renderRadioGroupForOrderNotification =
            this.renderRadioGroupForOrderNotification.bind(this);
        this.renderPaymentType = this.renderPaymentType.bind(this);
        this.renderOrderNotifications =
            this.renderOrderNotifications.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.renderViewMode = this.renderViewMode.bind(this);
        this.renderCancelReasons = this.renderCancelReasons.bind(this);
        this.renderInputs = this.renderInputs.bind(this);
        this.renderTextareaWithLabel = this.renderTextareaWithLabel.bind(this);
        this.renderInputWithLabel = this.renderInputWithLabel.bind(this);
        this.getValue = this.getValue.bind(this);
        this.setValue = this.setValue.bind(this);
        this.enableButton = this.enableButton.bind(this);
        this.disableButton = this.disableButton.bind(this);
        this.openMap = this.openMap.bind(this);
        this.saveHandler = this.saveHandler.bind(this);
        this.renderSelectShopsModal = this.renderSelectShopsModal.bind(this);
        this.renderPickedUpButton = this.renderPickedUpButton.bind(this);
        this.handleExportProductsCsv = this.handleExportProductsCsv.bind(this);

        this.renderAddressInputWithLabel = this.renderAddressInputWithLabel.bind(this);
        this.handleAddressChange = this.handleAddressChange.bind(this);
        this.handleAddressBlur = this.handleAddressBlur.bind(this);
        this.handleAddressSuggestionSelect =
            this.handleAddressSuggestionSelect.bind(this);
        this.handleDeliveryPriceReasonChange =
            this.handleDeliveryPriceReasonChange.bind(this);
        this.handleDeliveryPriceOtherDraftChange =
            this.handleDeliveryPriceOtherDraftChange.bind(this);
        this.handleDeliveryPriceOtherSave =
            this.handleDeliveryPriceOtherSave.bind(this);

        this._addressSuggestDebounce = null;
        this._addressSuggestRequestId = 0;
    }

    resetDeliveryPriceReasonState() {
        return getInitialDeliveryPriceReasonState();
    }

    isDeliveryPriceOtherReason(reason) {
        return Number(reason) === DELIVERY_PRICE_OTHER_REASON;
    }

    getDeliveryPriceReasonLabel(reason) {
        const found = DELIVERY_PRICE_CHANGE_REASONS.find(
            (opt) => opt.value === Number(reason),
        );
        return found ? found.label : String(reason);
    }

    getDeliveryPriceChangeHistory() {
        const fromState =
            (this.state &&
                this.state.orderDetails &&
                this.state.orderDetails.deliveryPriceChangeReasons) ||
            [];
        if (Array.isArray(fromState) && fromState.length) {
            return fromState;
        }
        const fromProps =
            (this.props &&
                this.props.orderDetails &&
                this.props.orderDetails.deliveryPriceChangeReasons) ||
            [];
        return Array.isArray(fromProps) ? fromProps : [];
    }

    renderDeliveryPriceChangeHistory() {
        const history = this.getDeliveryPriceChangeHistory();
        if (!history.length) {
            return null;
        }
        const items = history.slice().reverse();
        return (
            <div
                className="display-flex padding"
                key="deliveryPriceChangeHistory"
            >
                <label className="label-width">
                    {DELIVERY_PRICE_REASON_LABEL} — պատմություն:
                </label>
                <div className="my-custom-input margin-to-left default-font">
                    {items.map((entry, i) => {
                        const label = this.getDeliveryPriceReasonLabel(entry.reason);
                        const when = entry.changeTime
                            ? moment(entry.changeTime).format("DD/MM/YYYY HH:mm")
                            : "";
                        const pricePart =
                            typeof entry.oldPrice !== "undefined" ||
                            typeof entry.newPrice !== "undefined"
                                ? `${entry.oldPrice ?? ""} → ${entry.newPrice ?? ""}`
                                : "";
                        return (
                            <div
                                key={entry._id || `${entry.changeTime}-${i}`}
                                style={{
                                    padding: "6px 8px",
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                    marginBottom: "6px",
                                    background: "#f9f9f9",
                                }}
                            >
                                <div>
                                    <b>{label}</b>
                                    {pricePart ? ` (${pricePart})` : ""}
                                </div>
                                {entry.comment ? <div>{entry.comment}</div> : null}
                                <div style={{ color: "#777", fontSize: "12px" }}>
                                    {[entry.userName, when]
                                        .filter(Boolean)
                                        .join(" • ")}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    handleDeliveryPriceReasonChange(e) {
        const rawValue = e && e.target ? e.target.value : "";
        const nextReason = rawValue === "" ? "" : Number(rawValue);
        if (
            nextReason === "" ||
            !Number.isInteger(nextReason) ||
            nextReason < 1 ||
            nextReason > 7
        ) {
            this.setState({
                deliveryPriceReason: "",
                deliveryPriceOtherDraft: "",
                deliveryPriceOtherSaved: "",
                isDeliveryPriceUnlocked: false,
            });
            return;
        }
        if (this.isDeliveryPriceOtherReason(nextReason)) {
            this.setState({
                deliveryPriceReason: nextReason,
                deliveryPriceOtherDraft: "",
                deliveryPriceOtherSaved: "",
                isDeliveryPriceUnlocked: false,
            });
            return;
        }
        this.setState({
            deliveryPriceReason: nextReason,
            deliveryPriceOtherDraft: "",
            deliveryPriceOtherSaved: "",
            isDeliveryPriceUnlocked: true,
        });
    }

    handleDeliveryPriceOtherDraftChange(e) {
        const raw = e && e.target ? e.target.value : "";
        const value =
            raw.length > DELIVERY_PRICE_OTHER_MAX_LENGTH
                ? raw.slice(0, DELIVERY_PRICE_OTHER_MAX_LENGTH)
                : raw;
        this.setState({ deliveryPriceOtherDraft: value });
    }

    handleDeliveryPriceOtherSave() {
        const draft = (this.state.deliveryPriceOtherDraft || "").trim();
        if (!draft) {
            Notifier.error("Նշեք փոփոխման պատճառը", "_error_occurred_");
            return;
        }
        if (draft.length > DELIVERY_PRICE_OTHER_MAX_LENGTH) {
            Notifier.error(
                `Պատճառի նկարագրությունը չի կարող գերազանցել ${DELIVERY_PRICE_OTHER_MAX_LENGTH} նիշը`,
                "_error_occurred_",
            );
            return;
        }
        // Only a saved explanation unlocks the amount field for "Այլ".
        this.setState({
            deliveryPriceOtherSaved: draft,
            deliveryPriceOtherDraft: draft,
            isDeliveryPriceUnlocked: true,
        });
    }

    getOriginalDeliveryPrice() {
        if (
            this.props &&
            this.props.orderDetails &&
            typeof this.props.orderDetails.deliveryPrice !== "undefined"
        ) {
            return this.props.orderDetails.deliveryPrice;
        }
        return undefined;
    }

    isDeliveryPriceChanged() {
        const current =
            this.state &&
            this.state.orderDetails &&
            this.state.orderDetails.deliveryPrice;
        const original = this.getOriginalDeliveryPrice();
        if (typeof original === "undefined") {
            return false;
        }
        return String(current) !== String(original);
    }

    normalizeAddressSuggestions(payload) {
        const raw =
            (payload && payload.data && payload.data.data) ||
            (payload && payload.data) ||
            payload ||
            [];

        const list = Array.isArray(raw)
            ? raw
            : Array.isArray(raw?.suggestions)
                ? raw.suggestions
                : Array.isArray(raw?.items)
                    ? raw.items
                    : [];

        return (list || []).map((s, idx) => {
            if (typeof s === "string") {
                return {
                    id: `${idx}-${s}`,
                    label: s,
                    term: s,
                    raw: s,
                };
            }

            const label =
                s.address ||
                s.name ||
                s.label ||
                s.value ||
                s.text ||
                "";

            const term = s.address || s.term || s.value || s.query || label;

            return {
                id: s.id || s._id || `${idx}-${label}`,
                label,
                term,
                raw: s,
            };
        });
    }

    async fetchAddressSuggestions(term) {
        const trimmed = String(term || "").trim();
        if (!trimmed) {
            this.setState({
                addressSuggestions: [],
                addressSuggestionsLoading: false,
                showAddressSuggestions: false,
            });
            return;
        }

        const requestId = ++this._addressSuggestRequestId;
        this.setState({ addressSuggestionsLoading: true });

        try {
            const res = await axios.get(
                `https://dispatch.buy.am/geo/suggest-search`,
                {
                    params: { term: trimmed },
                },
            );

            if (requestId !== this._addressSuggestRequestId) {
                return;
            }

            const suggestions = this.normalizeAddressSuggestions(res);
            this.setState({
                addressSuggestions: suggestions,
                addressSuggestionsLoading: false,
                showAddressSuggestions: true,
            });
        } catch (e) {
            if (requestId !== this._addressSuggestRequestId) {
                return;
            }
            this.setState({
                addressSuggestions: [],
                addressSuggestionsLoading: false,
                showAddressSuggestions: false,
            });
        }
    }

    handleAddressChange(itemKey, e) {
        const value = e?.target?.value;
        this.setValue(itemKey, value);

        if (this._addressSuggestDebounce) {
            clearTimeout(this._addressSuggestDebounce);
        }

        this._addressSuggestDebounce = setTimeout(() => {
            this.fetchAddressSuggestions(value);
        }, 300);

        this.setState({ showAddressSuggestions: true });
        this.setState({});
    }

    handleAddressBlur() {
        setTimeout(() => {
            this.setState({ showAddressSuggestions: false });
        }, 200);
    }

    async handleAddressSuggestionSelect(itemKey, suggestion) {
        const address = suggestion?.raw?.address || "";
        const uri = suggestion?.raw?.uri || "";

        this.setValue(itemKey, address);

        this.setState({
            showAddressSuggestions: false,
            addressSuggestions: [],
        });

        try {
            // First, make the search call with the address (as before)
            await axios.get(`https://dispatch.buy.am/geo/search`, {
                params: { term: address },
            });

            // Then, if we have a URI, make another call to get coordinates
            if (uri) {
                const uriRes = await axios.get(`https://dispatch.buy.am/geo/search`, {
                    params: { term: uri },
                });

                const data = uriRes.data?.data;

                if (Array.isArray(data) && data.length > 0) {
                    const firstResult = data[0];
                    const lat = parseFloat(firstResult.lat);
                    const lng = parseFloat(firstResult.lng);

                    const districtNames = firstResult?.districtNames;

                    if (!isNaN(lat) && !isNaN(lng)) {
                        if (!this.state.orderDetails.receiver) {
                            this.state.orderDetails.receiver = {};
                        }
                        if (!this.state.orderDetails.receiver.location) {
                            this.state.orderDetails.receiver.location = {};
                        }
                        this.state.orderDetails.receiver.location.lat = lat;
                        this.state.orderDetails.receiver.location.lng = lng;
                        this.state.orderDetails.receiver.districts = districtNames;
                    }
                }
            }

            this.setState({});
        } catch (e) {
            this.setState({});
        }
    }

    renderAddressInputWithLabel(item, index, optionsWithoutKey, showOpenMapButton) {
        const uniqueKey = `${item.id}-${index}`;
        const itemKey = item.key;

        const addressOptions = {
            ...optionsWithoutKey,
            onChange: this.handleAddressChange.bind(this, itemKey),
            onBlur: this.handleAddressBlur,
        };

        const suggestions = this.state.addressSuggestions || [];
        const showSuggestions =
            !!this.state.showAddressSuggestions &&
            Array.isArray(suggestions) &&
            suggestions.length > 0;

        return (
            <div key={uniqueKey} style={{ display: optionsWithoutKey.display || "block", position: "relative" }}>
                {showOpenMapButton ? (
                    <Button
                        bsStyle={
                            this.state.orderDetails &&
                            this.state.orderDetails.receiver &&
                            this.state.orderDetails.receiver.location &&
                            this.state.orderDetails.receiver.location.lat
                                ? "primary"
                                : "danger"
                        }
                        className="btn-xs map-button"
                        onClick={this.openMap}
                    >
                        <span className="glyphicon glyphicon-map-marker" />
                    </Button>
                ) : null}

                <FormInput
                    key={index}
                    {...addressOptions}
                    inputStyle={showOpenMapButton ? "input-with-margin" : null}
                />

                {showSuggestions ? (
                    <div
                        className="suggestions-container"
                        style={{
                            position: "absolute",
                            left: 0,
                            right: 0,
                            top: "100%",
                            zIndex: 9999,
                            background: "#f5f5f5",
                            border: "1px solid #ddd",
                            maxHeight: 220,
                            overflowY: "auto",
                        }}
                    >
                        {suggestions.map((s) => (
                            <div
                                key={s.id}
                                className="suggestion-item"
                                style={{
                                    padding: "8px 10px",
                                    cursor: "pointer",
                                    borderBottom: "1px solid #eee",
                                }}
                                onMouseDown={(e) => {
                                    e.preventDefault();
                                    this.handleAddressSuggestionSelect(itemKey, s);
                                }}
                            >
                                {s.label}
                            </div>
                        ))}
                    </div>
                ) : null}
            </div>
        );
    }

    getOriginalOrderShops(orderDetails) {
        if (!orderDetails || !orderDetails.shops) {
            return [];
        }

        return orderDetails.shops.map((shop) => {

            const branches = shop.restaurantInfo?.branches?.map((br) => ({
                ...br,
                status: shop?.branch === br._id ? shop.state : 0,
            })) || [];

            return {
                ...shop,
                restaurantInfo: {
                    ...shop.restaurantInfo,
                    branches,
                    mainBranch: {
                        ...shop.restaurantInfo.mainBranch,
                        status: !shop?.branch ? shop.state : 0,
                    },
                },
            };
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const { orderDetails: nextOrderDetails } = this.props;
        const { orderDetails: prevOrderDetails } = prevProps;

        if (!nextOrderDetails) {
            return;
        }

        const role = security.getUser().role;
        this.editableFields = rolesConf.order.edit[role] || [];
        this.role = role;

        if (this.state.orderDetails !== prevState.orderDetails) {
            this.canBeChanged = this.state.orderDetails && PAYMENT_TYPES.paymentMethodsById(
                this.state.orderDetails.paymentType,
            ).canBeChanged;
        }

        const isOpen = !prevOrderDetails?.show && nextOrderDetails.show;
        if (isOpen) {
            this.handleModalOpen(nextOrderDetails);
        }

        if (prevOrderDetails?.show && nextOrderDetails.show) {
            this.handleOrderDetailsUpdate(prevOrderDetails, nextOrderDetails);
        }

        if (this.props.giftCards && !this.state.suggestions.length) {
            this.handleGiftCardsUpdate();
        }
    }

    handleModalOpen(nextOrderDetails) {
        const originalOrderShops = this.getOriginalOrderShops(nextOrderDetails);
        // Every order (across all 4 Ընթացիկ պատվերներ tabs sharing this modal)
        // starts locked: reason must be selected from scratch.
        this.setState({
            originalOrderShops,
            ...getInitialDeliveryPriceReasonState(),
        });

        this.processShops(nextOrderDetails.shops || []);
        this.props.getNewDistributorList();
    }

    handleOrderDetailsUpdate(prevOrderDetails, nextOrderDetails) {
        const shopsChanged = this.checkShopsChanged(
            prevOrderDetails.shops,
            nextOrderDetails.shops,
        );

        if (shopsChanged) {
            this.processShops(nextOrderDetails.shops || []);
        }

        const orderDetailsChanged = this.checkOrderDetailsChanged(
            prevOrderDetails,
            nextOrderDetails,
        );

        if (orderDetailsChanged) {
            this.setState({
                orderDetails: JSON.parse(JSON.stringify(nextOrderDetails)),
                // A different order must restart the reason → unlock flow.
                ...(prevOrderDetails.orderId !== nextOrderDetails.orderId
                    ? getInitialDeliveryPriceReasonState()
                    : {}),
            });
            return;
        }

        // Keep the reason history fresh (e.g. after socket updates) without
        // clobbering an unsaved delivery-amount edit in progress.
        try {
            const prevHistory = JSON.stringify(
                prevOrderDetails.deliveryPriceChangeReasons || [],
            );
            const nextHistory = JSON.stringify(
                nextOrderDetails.deliveryPriceChangeReasons || [],
            );
            if (prevHistory !== nextHistory) {
                this.setState((prevState) => ({
                    orderDetails: {
                        ...prevState.orderDetails,
                        deliveryPriceChangeReasons:
                            nextOrderDetails.deliveryPriceChangeReasons || [],
                    },
                }));
            }
        } catch (e) {
            console.error("Error syncing delivery price history:", e);
        }
    }

    checkShopsChanged(prevShops, nextShops) {
        if (!prevShops || !nextShops) {
            return prevShops !== nextShops;
        }

        if (prevShops.length !== nextShops.length) {
            return true;
        }

        return nextShops.some((shop, index) => {
            const prevShop = prevShops[index];

            return (
                shop.sendToPartner !== prevShop.sendToPartner ||
                shop.state !== prevShop.state ||
                shop.partner !== prevShop.partner ||
                shop.sendToPartnerDate !== prevShop.sendToPartnerDate ||
                shop.eta !== prevShop.eta ||
                this.checkProductsChanged(shop.products, prevShop.products)
            );
        });
    }

    checkProductsChanged(nextProducts, prevProducts) {
        if (!nextProducts || !prevProducts) {
            return nextProducts !== prevProducts;
        }

        if (nextProducts.length !== prevProducts.length) {
            return true;
        }

        return nextProducts.some((product, index) => {
            const prevProduct = prevProducts[index];
            return (
                product.discussion !== prevProduct.discussion ||
                product.partnerQuantity !== prevProduct.partnerQuantity ||
                product.quantity !== prevProduct.quantity
            );
        });
    }

    checkOrderDetailsChanged(prevOrderDetails, nextOrderDetails) {
        if (!prevOrderDetails || !nextOrderDetails) return true;

        return (
            prevOrderDetails.paymentType !== nextOrderDetails.paymentType ||
            prevOrderDetails.status !== nextOrderDetails.status ||
            JSON.stringify(prevOrderDetails.giftCardCodes) !==
            JSON.stringify(nextOrderDetails.giftCardCodes)
        );
    }

    processShops(shops) {
        // keep original merging logic, but emit new array ref so ShopList sees update immediately
        // previously only giftCardsCount was setState -> shops ref stayed same -> ShopList stale until next GET
        let giftCardsCount = 0;

        shops.forEach((shop) => {
            const isGiftCardShop =
                shop.shopId === GIFT_CARD_SHOP_ID ||
                (shop.restaurantInfo &&
                    shop.restaurantInfo.name === GIFT_CARD_SHOP_NAME);

            let storedShop =
                (this.state.orderDetails?.shops || []).find(
                    (item) => item._id && shop._id === item._id,
                ) || {};

            const products = storedShop.products || [];

            products.forEach((product) => {
                const updatedProduct = (shop.products || []).find(
                    (item) => item._id === product._id,
                );

                if (updatedProduct) {
                    if (updatedProduct.hasOwnProperty("discussion")) {
                        product.discussion = updatedProduct.discussion;
                    }
                    if (updatedProduct.hasOwnProperty("partnerQuantity")) {
                        product.partnerQuantity = updatedProduct.partnerQuantity;
                    }
                }

                if (isGiftCardShop) {
                    giftCardsCount += product.quantity;
                }
            });

            storedShop.state = shop.state;
            storedShop.partner = shop.partner;
            storedShop.sendToPartner = shop.sendToPartner;
            storedShop.sendToPartnerDate = shop.sendToPartnerDate;
            storedShop.eta = shop.eta;
        });
        const shouldUpdateGift = giftCardsCount > 0 || (giftCardsCount === 0 && this.state.giftCardsCount > 0);
        this.setState((prev) => {
            const base = { orderDetails: { ...prev.orderDetails, shops: [...(prev.orderDetails.shops || [])] } };
            if (shouldUpdateGift) base.giftCardsCount = giftCardsCount === 0 ? 0 : giftCardsCount;
            return base;
        });
    }

    handleGiftCardsUpdate() {
        this.setState({
            suggestions: (this.props.giftCards || [])
                .filter((item) => {
                    return (
                        !(
                            this.state.orderDetails.giftCardCodes &&
                            this.state.orderDetails.giftCardCodes.length &&
                            this.state.orderDetails.giftCardCodes.find(
                                (code) => code.id == item.cardId,
                            )
                        ) &&
                        Number(item.status) ===
                        GIFT_CARD_STATUSES.DRAFT.statusId
                    );
                })
                .map((giftCard) => ({
                    id: giftCard.cardId,
                    name: giftCard.cardCode,
                })),
        });
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (!nextProps.orderDetails) {
            return null;
        }

        const isOpen =
            !prevState.orderDetails.show && nextProps.orderDetails.show;

        const newOrderDetails = !isOpen && Object.keys(prevState.orderDetails).length
            ? prevState.orderDetails
            : JSON.parse(JSON.stringify(nextProps.orderDetails));

        if (newOrderDetails !== prevState.orderDetails) {
            return {
                orderDetails: newOrderDetails,
            };
        }

        return null;
    }

    renderDistributor() {
        if (this.state.orderDetails.bookId) {
            return null;
        }
        const canEdit = rolesConf.order.canEdit(
            this.role,
            this.state.orderDetails.status,
            this.state.orderMode,
            "distributor",
        );
        let title = translator.translate("_choose_distributor_label_");

        const { distributors, newDistributors } = this.props;

        const newDistributorsMap = new Map(
            newDistributors.map(item => [
                item._id,
                { finalCashBalance: item.finalCashBalance, vehicleType: item.vehicleType },
            ]),
        );

        const distributorsWithUpdatedAmount = distributors.map(distributor => {
            const nd = newDistributorsMap.get(distributor._id);
            const amount = nd?.finalCashBalance;
            const vehicleType = nd?.vehicleType ?? distributor.type ?? distributor.vehicleType ?? 1;
            const letter = getVehicleLetter(vehicleType);
            return {
                ...distributor,
                payableAmount: amount ?? distributor.payableAmount,
                type: vehicleType,
                vehicleLetter: letter,
            };
        });

        const distributor = getDistributor(
            this.props.orderDetails.distributor,
            distributorsWithUpdatedAmount,
        );
        // Enrich single distributor with vehicleLetter (for cases where it's not in list)
        let enrichedDistributor = distributor;
        if (distributor && distributor._id) {
            const nd = newDistributorsMap.get(distributor._id);
            const vehicleType = nd?.vehicleType ?? distributor.type ?? distributor.vehicleType;
            const letter = getVehicleLetter(vehicleType);
            if (letter && !distributor.vehicleLetter) {
                enrichedDistributor = { ...distributor, type: vehicleType, vehicleLetter: letter };
            }
        }
        const status = this.props.orderDetails.status;
        const canCancel = rolesConf.order.canCancelAssignment(
            this.role,
            status,
        );
        let disabled = false;
        if (
            this.props.locationSelection &&
            this.props.orderDetails &&
            this.props.orderDetails.receiver &&
            !(
                this.props.orderDetails.receiver.location &&
                this.props.orderDetails.receiver.location.lat
            )
        ) {
            disabled = true;
        }
        if (!canEdit) {
            const displayName = enrichedDistributor
                ? `${enrichedDistributor.vehicleLetter ? `(${enrichedDistributor.vehicleLetter}) ` : ""}${enrichedDistributor.name || ""}`.trim()
                : distributor
                    ? distributor.name
                    : "";
            const name = displayName;
            return (
                <InputWithLabel
                    key="distributor"
                    disabled={true}
                    htmlFor={"distributor"}
                    label={"_distributor_"}
                    type={"text"}
                    id={"distributor"}
                    value={name}
                    onChange={(e) => {
                    }}
                    style={{ add: true }}
                />
            );
        }
        const showAll =
            ORDER_STATUSES.DELIVERED.statusId === status ||
            ORDER_STATUSES.VERIFIED.statusId === status;

        return (
            <DistributorList
                key="distributor"
                title={title}
                canEdit={canEdit}
                order={this.state.orderDetails}
                choose={translator.translate("_choose_")}
                distributor={enrichedDistributor}
                canCancel={canCancel}
                showAll={showAll}
                dispatchResponse={this.props.dispatchResponse}
                onChange={(e) => {
                    this.state.orderDetails.distributor = e.value;
                }}
                isDisabled={disabled}
                distributors={distributorsWithUpdatedAmount}
                inModal={true}
            />
        );
    }

    getOrder(isInitialPriceChanged) {
        const order = {
            id: this.state.orderDetails._id,
            orderId: this.state.orderDetails.orderId,
            receiver: this.state.orderDetails.receiver,
            comments: this.state.orderDetails.comments,
            distributor: this.state.orderDetails.distributor,
            groupOrderDetails: this.state.orderDetails.groupOrderDetails || [],
            salaryType: this.state.orderDetails.salaryType,
            walletType: this.state.orderDetails.walletType,
            sendToEmail: this.state.orderDetails.sendToEmail,
            messageToRecipient: this.state.orderDetails.messageToRecipient,
            __v: +localStorage.getItem("v"),
        };

        if (this.state.orderDetails.bookId) {
            order.bookId = this.state.orderDetails.bookId;
        }

        if (this.state.orderDetails.serviceStatus) {
            order.serviceStatus = this.state.orderDetails.serviceStatus;
        }

        try {
            (this.editableFields || []).map((field) => {
                if (this.state.orderDetails.hasOwnProperty(field)) {
                    order[field] = this.state.orderDetails[field];
                }
                return field;
            });
        } catch (error) {
            console.error("Error in editableFields.map:", error);
            console.error("editableFields:", this.editableFields);
        }
        if (isInitialPriceChanged) {
            order.initialPrice = this.state.orderDetails.initialPrice;
        }
        if (this.state.orderDetails.shops) {
            order.shops = this.state.orderDetails.shops.map((shop) => {
                const processedShop = { ...shop };
                processedShop.readyTime = shop.readyTime ? new Date(shop.readyTime) : new Date(
                    moment(this.state.orderDetails.createdTime).add(
                        20,
                        "minutes",
                    ),
                );
                if (shop.restaurantInfo && shop.restaurantInfo._id) {
                    processedShop.restaurantInfo = shop.restaurantInfo._id;
                }
                return processedShop;
            });
        }

        try {
            if (this.isDeliveryPriceChanged()) {
                const reasonNumber = Number(this.state.deliveryPriceReason);
                if (
                    Number.isInteger(reasonNumber) &&
                    reasonNumber >= 1 &&
                    reasonNumber <= 7
                ) {
                    if (this.isDeliveryPriceOtherReason(reasonNumber)) {
                        const explanation = (this.state.deliveryPriceOtherSaved || "").trim();
                        order.deliveryPriceChangeReason = {
                            reason: reasonNumber,
                            comment: explanation,
                        };
                    } else {
                        order.deliveryPriceChangeReason = {
                            reason: reasonNumber,
                            comment: "",
                        };
                    }
                }
            }
        } catch (error) {
            console.error("Error attaching delivery price reason:", error);
        }

        return order;
    }

    validatePrice(shops) {
        const totalPrice = shops.reduce((sum, item) => {
            const itemTotal = item.products.reduce(
                (pSum, product) => pSum + parseFloat(product.price),
                0,
            );
            return sum + itemTotal;
        }, 0);
        return totalPrice > 0;
    }

    checkBranchChanges(original, copy) {
        return original.map((item, index) => {
            const copyBranch = copy[index] ? copy[index].branch : null;

            const currentBranchStatus = item.branch === "" || item.branch === null ?
                copy[index]?.restaurantInfo?.mainBranch?.status :
                copy[index]?.restaurantInfo?.branches?.find((br) => br._id === item.branch)?.status;

            return {
                isChanged: item.branch !== copyBranch && currentBranchStatus === 0,
            };

        });
    }

    save(hide = true, isInitialPriceChanged = false, isSplitChange = false) {
        // Client-side guard: a changed delivery amount requires a satisfied
        // reason gate. Backend (OMSNEW-1148) re-validates; this is UX only.
        // Super Admin is exempt from the gate entirely.
        const isSuperAdmin = this.role === USER_ROLES.SUPER_ADMIN;
        const deliveryPriceWasChanged = this.isDeliveryPriceChanged();
        const needsDeliveryPriceReason = deliveryPriceWasChanged && !isSuperAdmin;
        if (needsDeliveryPriceReason) {
            const reasonNumber = Number(this.state.deliveryPriceReason);
            const isOther = this.isDeliveryPriceOtherReason(reasonNumber);
            const savedExplanation = (this.state.deliveryPriceOtherSaved || "").trim();
            const reasonIsKnown =
                Number.isInteger(reasonNumber) && reasonNumber >= 1 && reasonNumber <= 7;

            if (
                !reasonIsKnown ||
                !this.state.isDeliveryPriceUnlocked ||
                this.state.deliveryPriceReason === ""
            ) {
                Notifier.error(
                    "Ընտրեք առաքման գումարի փոփոխման պատճառը",
                    "_order_update_failed_",
                );
                return;
            }
            if (isOther) {
                if (!savedExplanation) {
                    Notifier.error(
                        "Նշեք փոփոխման պատճառը",
                        "_order_update_failed_",
                    );
                    return;
                }
                if (savedExplanation.length > DELIVERY_PRICE_OTHER_MAX_LENGTH) {
                    Notifier.error(
                        `Պատճառի նկարագրությունը չի կարող գերազանցել ${DELIVERY_PRICE_OTHER_MAX_LENGTH} նիշը`,
                        "_order_update_failed_",
                    );
                    return;
                }
            }
        }

        const order = this.getOrder(isInitialPriceChanged);

        const changes = this.checkBranchChanges(order.shops, this.state.originalOrderShops);

        if (changes && changes.length > 0) {
            changes.forEach((change, index) => {
                if (change.isChanged && order.shops[index]) {
                    order.shops[index].state = 0;
                    order.shops[index].sendToPartner = false;
                }
            });
        }

        if (isSplitChange) {
            order.isSplitChange = true;
        }

        const isPriceNotValid =
            order.bookId &&
            order.serviceStatus === 5 &&
            !this.validatePrice(order.shops);
        if (this.state.invalidDate || isPriceNotValid) {
            const errMsg = this.state.invalidDate
                ? "_invalid_date_"
                : "_required_price_";
            Notifier.error(errMsg);
        } else if (needsDeliveryPriceReason) {
            // Defer hide/reset until the backend confirms success, so a
            // rejection keeps the dialog open with the reason still selected
            // and surfaces a clear error instead of silently closing.
            this.props.updateOrderByApi(
                order,
                (newOrder) => {
                    if (order.distributor !== this.props.orderDetails.distributor) {
                        this.props.assignDistributor({
                            orderId: order.orderId,
                            distributor: order.distributor,
                            manager: security.getUser()._id,
                        });
                    }
                    newOrder.userUpdate = true;
                    // Reset the gate, but keep the fresh history locally so it
                    // is visible immediately when the modal stays open
                    // (hide === false). On hide === true the modal closes and
                    // the next open loads history from props anyway.
                    const gateReset = this.resetDeliveryPriceReasonState();
                    const nextHistory = newOrder
                        ? newOrder.deliveryPriceChangeReasons
                        : undefined;
                    const nextPrice = newOrder
                        ? newOrder.deliveryPrice
                        : undefined;
                    if (
                        typeof nextHistory !== "undefined" ||
                        typeof nextPrice !== "undefined"
                    ) {
                        this.setState((prevState) => ({
                            ...gateReset,
                            orderDetails: {
                                ...prevState.orderDetails,
                                ...(typeof nextPrice !== "undefined"
                                    ? { deliveryPrice: nextPrice }
                                    : {}),
                                ...(typeof nextHistory !== "undefined"
                                    ? { deliveryPriceChangeReasons: nextHistory }
                                    : {}),
                            },
                        }));
                    } else {
                        this.setState(gateReset);
                    }
                    if (hide) {
                        this.hide();
                    }
                },
                (errorMessage) => {
                    Notifier.error(
                        errorMessage ||
                        "Առաքման գումարի պահպանումը ձախողվեց՝ ստուգեք փոփոխման պատճառը",
                        "_order_update_failed_",
                    );
                },
            );
        } else {
            this.props.updateOrderByApi(order, (newOrder) => {
                if (order.distributor !== this.props.orderDetails.distributor) {
                    this.props.assignDistributor({
                        orderId: order.orderId,
                        distributor: order.distributor,
                        manager: security.getUser()._id,
                    });
                }
                newOrder.userUpdate = true;
            });
            if (hide) {
                this.hide();
            }
        }
    }

    hide() {
        this.canBeChanged = true;
        this.setState({
            orderDetails: {},
            canSave: true,
            orderMode: ORDER_DETAILS_MODE.MODES.edit_mode,
            showPaymentDetails: false,
            isOtherReason: false,
            totalShopsPrice: 0,
            totalPaidAmount: 0,
            comment: "",
            invalidDate: false,
            cancelReason: CANCEL_REASONS.CUSTOMER_DUPLICATE.id,
            toggleActive: false,
            suggestions: [],
            shops: [],
            giftCardsCount: 0,
            selectedShops: [],
            originalOrderShops: [],
            exportingProductsCsv: false,
            ...getInitialDeliveryPriceReasonState(),
        });
        this.props.closeOrderDetails();
    }

    saveHandlerForCancel() {
        const order = this.getOrder();
        let cancelData = {
            cancelReason: {
                reason: this.state.cancelReason,
                comment: this.state.comment,
            },
        };
        if (order.bookId) {
            this.props.cancelBookedOrderByApi(order.bookId, cancelData);
        } else {
            this.props.cancelOrderByApi(order.orderId, cancelData);
        }
        this.hide();
    }

    saveHandlerForRestore() {
        const order = this.getOrder();
        this.props.restoreOrderByApi(order.orderId);
        this.hide();
    }

    saveHandler() {
        if (!this.state.orderDetails?.receiver.location?.lat) {
            Notifier.warning(translator.translate("_failed_address_location_"));
        }

        if (this.state.orderDetails?.giftCardCodes?.length) {
            const codes = this.state.orderDetails.giftCardCodes;
            const duplicates = codes.filter((item, index) => {
                return codes.findIndex(x => x.code === item.code) !== index;
            });

            if (duplicates.length > 0) {
                return Notifier.error(
                    "Պահպանումը ձախողվեց՝ ոչ վավեր նվեր քարտի կոդ",
                    "_order_update_failed_",
                );
            }
        }

        const userRole = security.getUser()?.role;
        const isOrderManager = userRole === USER_ROLES.ORDER_MANAGER;

        let showWarning = false;

        const validations = [
            {
                condition: isOrderManager &&
                    this.state.orderDetails.status === 1 &&
                    this.state.orderDetails.shops.some((shop, i) => {
                        let isNeedToSend = shop?.restaurantInfo.branches.length ?
                            shop.restaurantInfo.branches.find((branch) => shop.branch ? (branch._id === shop.branch) : shop.restaurantInfo)?.restaurantInformation.isSupplier :
                            shop.restaurantInfo?.restaurantInformation?.isSupplier;
                        return (
                            shop.state === 0 && isNeedToSend
                        );
                    }),

                action: () => {
                    showWarning = true;
                },
            },
            {
                condition: isOrderManager &&
                    this.state.orderDetails?.shops.some((shop, i) => {
                        const allBranches = shop?.restaurantInfo?.branches;

                        const isNeedSendToSupplier = shop?.branch ?
                            allBranches.find((branch) => branch._id === shop.branch)?.restaurantInformation.isSupplier
                            : shop.restaurantInfo.isSupplier;

                        const orderShopsProps = this.state.originalOrderShops || this.props.orderDetails.shops;

                        const currentBranchStatus = shop?.branch ?
                            orderShopsProps[i]?.restaurantInfo?.branches.find((br) => br._id === shop.branch)?.status
                            : orderShopsProps[i]?.restaurantInfo?.mainBranch?.status;

                        return currentBranchStatus === 0 && isNeedSendToSupplier;
                    }),
                action: () => {
                    showWarning = true;
                },
            },
        ];

        for (const v of validations) {
            if (v.condition) {
                v.action();
            }
        }

        if (showWarning) {
            Notifier.warning(translator.translate("order_not_sent_to_partner"));
        }

        const modeActions = {
            [ORDER_DETAILS_MODE.MODES.cancel_mode]: this.saveHandlerForCancel.bind(this),
            [ORDER_DETAILS_MODE.MODES.restore_mode]: this.saveHandlerForRestore.bind(this),
        };

        return (modeActions[this.state.orderMode] || this.save).call(this);
    }

    renderFooter() {
        const { canSave, orderMode, showPaymentDetails } = this.state;
        if (
            !rolesConf.order.canEdit(
                this.role,
                this.state.orderDetails.status,
                orderMode,
                "save",
            )
        ) {
            return null;
        }
        return (
            <Modal.Footer>
                <FooterButtons
                    cancelButton={translator.translate("_cancel_")}
                    saveButton={translator.translate("_save_")}
                    save={this.saveHandler}
                    isDisabled={
                        !canSave ||
                        showPaymentDetails ||
                        this.props.orderDetails.isFinanceChecked
                    }
                    cancel={this.hide.bind(this)}
                />
            </Modal.Footer>
        );
    }

    updateTotal = () => {
        const { orderDetails } = this.state;

        if (!orderDetails || !orderDetails.shops) return;

        let totalShopsPrice = 0;
        let totalPaidAmount = 0;
        let giftCardsCount = 0;

        orderDetails.shops.forEach((shop) => {
            totalShopsPrice += shop.price || 0;

            // Example: if you track paid amounts per shop
            totalPaidAmount += shop.paidAmount || 0;

            // Count gift cards if needed
            giftCardsCount += shop.giftCardsCount || 0;
        });

        this.setState({
            totalShopsPrice,
            totalPaidAmount,
            giftCardsCount,
        });
    };

    applyProductChanges = (value, property, shopIndex, productIndex) => {
        this.setState((prevState) => {
            const orderDetails = { ...prevState.orderDetails };

            try {
                orderDetails.shops = (orderDetails.shops || []).map((shop, sIdx) => {
                    if (sIdx !== shopIndex) return shop;

                    const products = (shop.products || []).map((product, pIdx) => {
                        if (pIdx !== productIndex) return product;
                        return { ...product, [property]: value };
                    });

                    const price = products.reduce((sum, p) => sum + (p.price || 0) * (p.quantity || 0), 0);
                    const driverExpenses = products.reduce(
                        (sum, p) => sum + (p.driverExpenses || 0) * (p.quantity || 0),
                        0,
                    );

                    return { ...shop, products, price, driverExpenses };
                });
            } catch (error) {
                console.error("Error in applyProductChanges:", error);
                console.error("orderDetails.shops:", orderDetails.shops);
            }

            return { orderDetails };
        }, this.updateTotal);
    };

    comment = (product) => {
        const { message, _id } = product;

        if (!message) {
            return;
        }

        const user = security.getUser();

        const newDiscussionItem = {
            sender: user._id,
            message,
            role: user.role,
            date: new Date(),
        };

        this.setState(prevState => {
            const prevOrderDetails = prevState.orderDetails || {};
            const updatedShops = (prevOrderDetails.shops || []).map(shop => {
                const updatedProducts = (shop.products || []).map(p => {
                    if (p._id !== _id) {
                        return p;
                    }

                    const prevDiscussion = p.discussion || [];

                    return {
                        ...p,
                        discussion: [...prevDiscussion, newDiscussionItem],
                        message: "",
                    };
                });

                return {
                    ...shop,
                    products: updatedProducts,
                };
            });

            return {
                orderDetails: {
                    ...prevOrderDetails,
                    shops: updatedShops,
                },
            };
        }, this.updateTotal);

        this.props.updateProduct({ message, _id }, this.state.orderDetails._id);
    };

    sendToPartner = (shop, isUpdateState = false) => {
        this.disableButton();

        const updatedShops = this.state.originalOrderShops.map((sh) => {
            if (sh._id !== shop._id) return sh;

            if (shop.branch) {
                const branchId = typeof shop.branch === "object" ? shop.branch._id : shop.branch;

                return {
                    ...sh,
                    restaurantInfo: {
                        ...sh.restaurantInfo,
                        branches: (sh.restaurantInfo?.branches || []).map((b) =>
                            b._id === branchId
                                ? { ...b, status: 6 }
                                : b,
                        ),
                    },
                };
            }

            return {
                ...sh,
                restaurantInfo: {
                    ...sh.restaurantInfo,
                    mainBranch: {
                        ...sh.restaurantInfo.mainBranch,
                        status: 6,
                    },
                },
            };
        });

        const apiCall = isUpdateState
            ? this.props.updateShopState(shop, this.state.orderDetails._id)
            : this.props.sendToPartner(this.state.orderDetails._id, shop);

        Promise.resolve(apiCall)
            .then(() => {
                this.setState({
                    originalOrderShops: updatedShops,
                });
                this.enableButton();
                Notifier.success(translator.translate("_send_to_partner_date_"));
            })
            .catch(error => {
                this.enableButton();
                Notifier.error("_send_to_partner_error_");
            });
    };

    canExportProductsCsv() {
        const isCancelled = this.state.orderDetails?.status === ORDER_STATUS.CANCELED?.statusId || this.state.orderDetails?.status === undefined;

        const role = (security.getUser() || {}).role;

        return !isCancelled && [
            USER_ROLES.ORDER_MANAGER,
            USER_ROLES.SUPER_ADMIN,
        ].includes(role);
    }

    getExportFilename(disposition, fallbackName) {
        if (disposition) {
            const utf8Match = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(disposition);
            if (utf8Match && utf8Match[1]) {
                try {
                    return decodeURIComponent(utf8Match[1].replace(/^"|"$/g, "").trim());
                } catch (e) {
                    return utf8Match[1].replace(/^"|"$/g, "").trim();
                }
            }
            const asciiMatch = /filename\s*=\s*("([^"]+)"|([^;]+))/i.exec(disposition);
            if (asciiMatch) {
                const name = (asciiMatch[2] || asciiMatch[3] || "").trim();
                if (name) {
                    return name;
                }
            }
        }
        return fallbackName;
    }

    async handleExportProductsCsv() {
        const orderMongoId =
            (this.state.orderDetails && this.state.orderDetails._id) ||
            (this.props.orderDetails && this.props.orderDetails._id);

        if (!orderMongoId) {
            Notifier.error("sysERR_CANT_EXPORT_ORDER");
            return;
        }

        if (!this.canExportProductsCsv()) {
            Notifier.error("sysACCESS_DENIED");
            return;
        }

        if (this.state.exportingProductsCsv) {
            return;
        }

        this.setState({ exportingProductsCsv: true });

        try {
            const res = await axios.get(
                `${BASE_URL}v2/order/${orderMongoId}/products/export`,
                { responseType: "blob" },
            );

            const disposition =
                (res.headers &&
                    (res.headers["content-disposition"] ||
                        res.headers["Content-Disposition"])) ||
                null;
            const orderNumber =
                this.state.orderDetails.orderId ||
                this.props.orderDetails.orderId ||
                orderMongoId;
            const fallbackName = `order-${orderNumber}-products.csv`;
            const filename = this.getExportFilename(disposition, fallbackName);

            const contentType =
                (res.headers &&
                    (res.headers["content-type"] ||
                        res.headers["Content-Type"])) ||
                "text/csv";
            const blob =
                res.data instanceof Blob
                    ? res.data
                    : new Blob([res.data], { type: contentType });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            const status = err && err.response && err.response.status;
            if (status === 401 || status === 403) {
                Notifier.error("sysACCESS_DENIED");
            } else if (status === 404) {
                Notifier.error("sysERR_CANT_FIND_ORDER");
            } else {
                Notifier.error("sysERR_CANT_EXPORT_ORDER");
            }
        } finally {
            this.setState({ exportingProductsCsv: false });
        }
    }

    renderShopList(editable) {
        return (
            <ShopList
                key={`shop-list-${this.state.orderDetails.shops ? this.state.orderDetails.shops.length : 0}`}
                canEdit={editable}
                expanded={editable}
                source={this.state.orderDetails.source}
                updatedByWeb={this.state.orderDetails.updatedByWeb}
                shops={this.state.orderDetails.shops}
                orderDetails={this.state.orderDetails}
                originalOrderShops={this.state.originalOrderShops}
                deliveryTime={this.state.orderDetails.deliveryTime}
                invalidDate={this.state.invalidDate}
                dateValidation={this.dateValidation.bind(this)}
                productHandler={(e, i) => {
                    const newOrderDetails = {
                        ...this.state.orderDetails,
                        shops: (this.state.orderDetails.shops || []).map((shop, index) => {
                            if (index !== i) return shop;

                            const updatedProducts = (shop.products || []).map((product, pIndex) => {
                                if (pIndex !== 0) return product;

                                return {
                                    ...product,
                                    name: e.target.value,
                                };
                            });

                            return {
                                ...shop,
                                products: updatedProducts,
                            };
                        }),
                    };

                    this.setState({ orderDetails: newOrderDetails });
                }}
                removeProduct={(products, product, shopId, productIndex) => {
                    const updatedShops = (this.state.orderDetails.shops || []).map(shop => {
                        if (shop._id === shopId) {
                            const updatedProducts = (shop.products || []).filter((p, i) => i !== productIndex);
                            return {
                                ...shop,
                                products: updatedProducts,
                                driverExpenses: shop.driverExpenses - product.driverExpenses * product.quantity,
                                price: shop.price - product.price * product.quantity,
                            };
                        }
                        return shop;
                    });

                    this.setState({
                        orderDetails: {
                            ...this.state.orderDetails,
                            shops: updatedShops,
                        },
                    }, () => {
                        this.updateTotal();
                    });
                }}
                removeShop={(shops, item, index) => {
                    const updatedShops = [...shops];
                    updatedShops.splice(index, 1);

                    this.setState({
                        orderDetails: {
                            ...this.state.orderDetails,
                            shops: updatedShops,
                        },
                        originalOrderShops: updatedShops,
                    }, () => {
                        this.updateTotal();
                    });
                }}
                sendToPartner={this.sendToPartner}
                priceHandler={(e, i) => {
                    const updatedShops = [...this.state.orderDetails.shops];
                    updatedShops[i].price = e.target.value;

                    this.setState({
                        orderDetails: {
                            ...this.state.orderDetails,
                            shops: updatedShops,
                        },
                    }, () => {
                        this.updateTotal();
                    });
                }}
                hdmNumberHandler={(e, i) => {
                    const updatedShops = [...this.state.orderDetails.shops];
                    updatedShops[i].hdmNumber = e.target.value;

                    this.setState({
                        orderDetails: {
                            ...this.state.orderDetails,
                            shops: updatedShops,
                        },
                    });
                }}
                driverExpensesHandler={(e, i) => {
                    const updatedShops = [...this.state.orderDetails.shops];
                    updatedShops[i].driverExpenses = e.target.value;

                    this.setState({
                        orderDetails: {
                            ...this.state.orderDetails,
                            shops: updatedShops,
                        },
                    }, () => {
                        this.updateTotal();
                    });
                }}
                collectedOrderAmountHandler={(e, i) => {
                    const updatedShops = [...this.state.orderDetails.shops];
                    updatedShops[i].collectedOrderAmount = e.target.value;

                    if (
                        this.state.orderDetails.paymentType !==
                        PAYMENT_TYPES.BANK_TRANSACTION.id &&
                        this.state.orderDetails.paymentType !==
                        PAYMENT_TYPES.POS_TERMINAL.id
                    ) {
                        const actualAmount = calculateActualAmount(
                            this.state.orderDetails,
                        );
                        if (actualAmount > this.state.orderDetails.price) {
                            updatedShops[0].cacheIn =
                                actualAmount - this.state.orderDetails.price;
                        } else {
                            updatedShops[0].cacheIn = 0;
                        }
                        if (
                            this.state.orderDetails.paymentType !==
                            PAYMENT_TYPES.AFTER_DELIVERY.id
                        ) {
                            this.addCacheInHint(
                                updatedShops[0].cacheIn,
                                this.state.orderDetails.hint,
                            );
                        }
                    }

                    this.setState({
                        orderDetails: {
                            ...this.state.orderDetails,
                            shops: updatedShops,
                        },
                    });
                }}
                readyTimeHandler={(e, i) => {
                    const updatedShops = [...this.state.orderDetails.shops];
                    updatedShops[i].readyTime = e;

                    this.setState({
                        orderDetails: {
                            ...this.state.orderDetails,
                            shops: updatedShops,
                        },
                    });
                }}
                productChanged={(e, property, shopIndex, productIndex) => {
                    this.applyProductChanges(
                        e.target.value,
                        property,
                        shopIndex,
                        productIndex,
                    );
                }}
                onQuantityChanged={(e, property, shopIndex, productIndex) => {
                    const quantity = Number(e.target.value) || 1;
                    this.applyProductChanges(
                        quantity,
                        property,
                        shopIndex,
                        productIndex,
                    );
                }}
                branchHandler={async (branchId, i) => {
                    const shop = this.state.orderDetails.shops[i];

                    let branches = shop.restaurantInfo?.branches || [];

                    if (!branches || branches.length === 0) {
                        const restaurantFromProps = this.props.restaurants?.find(
                            r => r._id === shop.restaurantInfo?._id,
                        );
                        if (restaurantFromProps?.branches && restaurantFromProps.branches.length > 0) {
                            branches = restaurantFromProps.branches;
                        } else if (shop.restaurantInfo?._id) {
                            try {
                                const response = await axios.get(`${BASE_URL}v2/restaurant/${shop.restaurantInfo._id}`);
                                if (response.data && Array.isArray(response.data) && response.data.length > 0) {
                                    branches = response.data[0].branches || [];
                                }
                            } catch (error) {
                                console.error("Error loading branches from API:", error);
                            }
                        }
                    }

                    const updatedShops = this.state.orderDetails.shops.map((shopItem, index) => {
                        if (index !== i) {
                            if (shopItem.restaurantInfo && (!shopItem.restaurantInfo.branches || shopItem.restaurantInfo.branches.length === 0)) {
                                const restaurantFromProps = this.props.restaurants?.find(
                                    r => r._id === shopItem.restaurantInfo?._id,
                                );
                                if (restaurantFromProps?.branches && restaurantFromProps.branches.length > 0) {
                                    return {
                                        ...shopItem,
                                        restaurantInfo: {
                                            ...shopItem.restaurantInfo,
                                            branches: restaurantFromProps.branches,
                                        },
                                    };
                                }
                            }
                            return shopItem;
                        }

                        const restaurantInfo = shop.restaurantInfo ? {
                            ...shop.restaurantInfo,
                            branches: branches,
                        } : shop.restaurantInfo;

                        return {
                            ...shop,
                            restaurantInfo: restaurantInfo,
                            branch: branchId,
                            suggestedBranch: null,
                            location: shop.location ? {
                                ...shop.location,
                                address: "",
                            } : shop.location,
                        };
                    });

                    this.setState({
                        orderDetails: {
                            ...this.state.orderDetails,
                            shops: updatedShops,
                        },
                    });
                }}
                modalCanSave={(e) => {
                    this.setState({ canSave: e });
                }}
                comment={this.comment}
                differences={this.state.orderDetails.differences}
                restaurants={this.state.orderDetails.restaurants}
                orderId={this.state.orderDetails.orderId}
                status={this.state.orderDetails.status}
                canSelectShop={!this.state.orderDetails.parentOrderId}
                isSelected={(item) => {
                    return !!(this.state.selectedShops || []).find(
                        (el) => el._id === item._id,
                    );
                }}
                selectShopForDivision={(item, selected) => {
                    let { selectedShops } = this.state;
                    if (selected) {
                        selectedShops.push(item);
                    } else {
                        selectedShops = selectedShops.filter(
                            (el) => el._id !== item._id,
                        );
                    }
                    this.setState({ selectedShops });
                }}
            />
        );
    }

    renderShops() {
        const editable = rolesConf.order.canEdit(
            this.role,
            this.state.orderDetails.status,
            this.state.orderMode,
            "shops",
        );
        return (
            <CollapseList
                isList={false}
                expanded={editable}
                key={`shops-${this.state.orderDetails.shops ? this.state.orderDetails.shops.length : 0}`}
                headerTitle={translator.translate("_locations_label_")}
                child={this.renderShopList(editable)}
                childClassName={`shop-list`}
                orderDetails={this.state.orderDetails}
                editable={editable}
                restaurants={this.props.restaurants}
                canExportProductsCsv={this.canExportProductsCsv()}
                exportingProductsCsv={this.state.exportingProductsCsv}
                onExportProductsCsv={this.handleExportProductsCsv}
                addShop={async (restaurant) => {
                    const fullRestaurantInfo = this.props.restaurants.find(r => r._id === restaurant._id) || restaurant;

                    let newRestaurantInfo = null;
                    let newBranches = fullRestaurantInfo.branches || [];

                    try {
                        const idsString = fullRestaurantInfo._id;
                        const response = await axios.get(`${BASE_URL}v2/restaurant/${idsString}`);
                        if (response.data && Array.isArray(response.data) && response.data.length > 0) {
                            newRestaurantInfo = response.data[0];
                            newBranches = newRestaurantInfo.branches || newBranches;
                        }
                    } catch (error) {
                        console.error("Error fetching restaurant info:", error);
                    }

                    let newShopData = {
                        restaurantInfo: {
                            ...fullRestaurantInfo,
                            branches: newBranches,
                            isSupplier: newRestaurantInfo?.isSupplier,
                            mainBranch: {
                                isActive: newRestaurantInfo?.restaurantInformation?.isActive,
                                isSupplier: newRestaurantInfo?.restaurantInformation?.isSupplier,
                                status: 0,
                            },
                        },
                        orderId: this.state.orderDetails.orderId,
                        price: 0,
                        state: 0,
                        driverExpenses: 0,
                        company: restaurant.company,
                        isRestaurant: restaurant.type === RESTAURANT_TYPES.RESTAURANT.id,
                        shopName: restaurant.name,
                        products: [
                            {
                                name: "",
                                price: "",
                                driverExpenses: "",
                                quantity: 1,
                            },
                        ],
                        shopId: restaurant.nRestaurantId,
                    };

                    const updatedOriginalOrderShops = [
                        newShopData,
                        ...this.state.originalOrderShops,
                    ];

                    const updatedOrderDetails = {
                        ...this.state.orderDetails,
                        shops: [newShopData, ...this.state.orderDetails.shops],
                    };

                    this.setState({
                        orderDetails: updatedOrderDetails,
                        originalOrderShops: updatedOriginalOrderShops,
                    }, () => {
                        this.updateTotal();
                    });
                }}
                divideOrder={() => {
                    const { orderDetails, selectedShops } = this.state;

                    if (!selectedShops.length || selectedShops.length === orderDetails.shops.length) return;

                    const newShops = selectedShops.map((shop) => {
                        const { isActive, ...rest } = shop;
                        const originalShop = (orderDetails.shops || []).find(s => s.shopId === shop.shopId) || shop;
                        return {
                            ...rest,
                            restaurantInfo: originalShop.restaurantInfo._id || null,
                        };
                    });

                    const newDeliveryPrice = selectedShops.reduce((acc, shop) => {
                        return acc + (shop.deliveryPrice || DEFAULT_DELIVERY_PRICE);
                    }, 0);

                    const priceToSubtract = selectedShops.reduce((acc, item) => {
                        acc += parseInt(item.price) + (item.deliveryPrice || DEFAULT_DELIVERY_PRICE);
                        return acc;
                    }, 0);

                    const payload = {
                        shops: newShops,
                        deliveryPrice: newDeliveryPrice,
                        isSplitOrder: true,
                        parentOrderId: orderDetails.orderId,
                        customer: orderDetails.customer,
                        status: orderDetails.status,
                        source: orderDetails.source,
                        currency: orderDetails.currency,
                        eta: orderDetails.eta,
                        paymentType: orderDetails.paymentType,
                        giftCardAmount: orderDetails.giftCardAmount,
                        additionalPaymentType: orderDetails.additionalPaymentType,
                        isPromotionOrder: orderDetails.isPromotionOrder,
                        canReplaceProducts: orderDetails.canReplaceProducts,
                        isChangesAccepted: orderDetails.isChangesAccepted,
                        isTransferred: orderDetails.isTransferred,
                        isRefunded: orderDetails.isRefunded,
                        betaOrder: orderDetails.betaOrder,
                        isBookService: orderDetails.isBookService,
                        suspiciousTransactionsList: orderDetails.suspiciousTransactionsList,
                        salaryType: orderDetails.salaryType,
                        orderFormat: orderDetails.orderFormat,
                        modification: orderDetails.modification,
                        orderId: orderDetails.orderId,
                        deliveryCode: orderDetails.deliveryCode,
                        discountCode: orderDetails.discountCode,
                        deliveryDayStartTime: orderDetails.deliveryDayStartTime,
                        deliveryDayEndTime: orderDetails.deliveryDayEndTime,
                        cardType: orderDetails.cardType,
                        walletType: orderDetails.walletType,
                        price: orderDetails.price,
                        comments: orderDetails.comments,
                        createdTime: orderDetails.createdTime,
                        deliveryTime: orderDetails.deliveryTime,
                        paymentTransaction: orderDetails.paymentTransaction,
                        imTaxCode: orderDetails.imTaxCode,
                        transactionId: orderDetails.transactionId,
                        receiver: orderDetails.receiver,
                        payerId: orderDetails.payerId,
                        calculatedDeliveryPrice: orderDetails.calculatedDeliveryPrice,
                        paidAmount: orderDetails.paidAmount,
                        initialPrice: orderDetails.initialPrice,
                        notes: orderDetails.notes,
                        hint: orderDetails.hint,
                        orderType: orderDetails.orderType,
                        distributorRejectionReasons: orderDetails.distributorRejectionReasons,
                    };

                    this.props.divideOrder(payload, (err) => {
                        if (!err) {
                            this.save(false, true, true);
                        }
                    });

                    const remainingShops = orderDetails.shops.filter(s => !selectedShops.includes(s));

                    this.setState({
                        selectedShops: [],
                        orderDetails: {
                            ...orderDetails,
                            shops: remainingShops,
                            deliveryPrice: orderDetails.deliveryPrice - newDeliveryPrice,
                            initialPrice: orderDetails.initialPrice - priceToSubtract,
                            isSplitOrder: true,
                        },
                    }, () => {
                        this.updateTotal();
                    });
                }}
                divideOrderAuto={() => {
                    this.props.divideOrderAuto(this.state.orderDetails, () => {
                        this.hide();
                    });
                }}
                mergeOrder={() => {
                    const options = {
                        customerId: this.state.orderDetails.customer.customerId || "",
                    };
                    if (this.state.orderDetails.parentOrderId) {
                        options.parentOrderId = this.state.orderDetails.parentOrderId;
                    } else {
                        options.orderId = this.state.orderDetails.orderId;
                    }
                    this.props.getShopsForMergeOrder(options, (data) => {
                        if (data && data.length) {
                            this.setState({ selectShopsModalData: data });
                        }
                    });
                }}
            />
        );
    }

    renderSelectShopsModal() {
        if (!this.state.selectShopsModalData) {
            return null;
        }
        return (
            <SelectShopsForMergeModal
                show={!!this.state.selectShopsModalData}
                hide={() => this.setState({ selectShopsModalData: null })}
                save={(shops, comments) => {
                    if (shops && shops.length) {
                        let cityDeliveryPrice = this.state.orderDetails.deliveryPrice;
                        this.state.orderDetails.shops.forEach((shop) => {
                            cityDeliveryPrice -=
                                shop.deliveryPrice || DEFAULT_DELIVERY_PRICE;
                        });
                        let newDeliveryPrice = cityDeliveryPrice;
                        shops.forEach((shop) => {
                            newDeliveryPrice +=
                                shop.deliveryPrice || DEFAULT_DELIVERY_PRICE;
                        });
                        this.setState({
                            orderDetails: {
                                ...this.state.orderDetails,
                                shops: shops,
                                deliveryPrice: newDeliveryPrice,
                                comments: this.state.orderDetails.comments + comments,
                            },
                        }, () => {
                            this.updateTotal();
                            this.save(false);
                            this.setState({ selectShopsModalData: null });
                        });
                    }
                }}
                data={this.state.selectShopsModalData}
                shops={this.state.orderDetails.shops}
                mainOrderId={this.state.orderDetails.orderId}
            />
        );
    }

    propertyWasChanged(property) {
        let changed = false;
        const diff = this.state.orderDetails.differences || [];
        diff.forEach((item) => {
            let result = true;
            if ("object" === typeof property) {
                property.forEach((key) => {
                    result = result && -1 !== item.path.indexOf(key);
                });
            } else if ("string" === typeof property) {
                result = item.path[0] === property;
            }
            changed = changed || result;
        });
        return changed;
    }

    addCacheInHint(cacheIn, hint) {
        const cache = translator.translate("_cash_") + " ";
        cacheIn = cacheIn || 0;
        hint = hint || "";
        const strCacheIn =
            cacheIn > 0 ? COMPARATIONS.ADD + cacheIn + " " : cacheIn + " ";
        let hintArray = hint.split(" ");
        const cacheIndex = hintArray.indexOf(translator.translate("_cash_"));
        if (cacheIndex > -1) {
            if (Number(cacheIn) === 0) {
                hintArray.splice(cacheIndex, 2);
                hint = hintArray.join(" ");
                return (this.state.orderDetails["hint"] = hint);
            }
            hintArray[cacheIndex + 1] = strCacheIn;
            hint = hintArray.join(" ");
            return (this.state.orderDetails["hint"] = hint);
        } else if (Number(cacheIn) !== 0) {
            hint = cache + strCacheIn + " " + hint;
            return (this.state.orderDetails["hint"] = hint);
        }
    }

    getValue(key, format) {
        let value = "";
        if ("string" === typeof key) {
            value = this.state.orderDetails[key];
        } else if ("object" === typeof key) {
            value = this.state.orderDetails;
            key.forEach((property, i) => {
                value = value[property] || "";
            });
        }
        if (format === "date" && value) {
            value = moment(value).format("DD/MM/YYYY HH:mm");
        }
        return value;
    }

    setValue(key, value) {
        if (!key) {
            return;
        }
        if (key === "cacheIn") {
            this.state.orderDetails.shops[0].cacheIn = value;
            this.addCacheInHint(value, this.state.orderDetails["hint"]);
        }
        if (key === "hint") {
            this.addCacheInHint(this.state.orderDetails.shops[0].cacheIn, value);
        }
        if ("string" === typeof key) {
            this.state.orderDetails[key] = value;
        } else if ("object" === typeof key) {
            let result = this.state.orderDetails;
            key.forEach((property, i) => {
                if (i === key.length - 1) {
                    result[property] = value;
                    return;
                }
                result = result[property] || "";
            });
        }
    }

    renderRadioGroup(data, index) {

        const { bonusAmount, walletType, discount } = this.state.orderDetails;
        const paymentMethodsDisabled =
            PAYMENT_TYPES.getNotEditablePaymentMethods().includes(
                this.props.orderDetails.paymentType,
            );
        let editable = rolesConf.order.canEdit(
            this.role,
            this.state.orderDetails.status,
            this.state.orderMode,
            "paymentType",
        );

        const isBonus = data.walletType === WALLET_TYPES.BONUS;
        const isBonusChecked = walletType === WALLET_TYPES.BONUS && bonusAmount;
        const isCorporateBonus =
            data.walletType === WALLET_TYPES.CORPORATE_BONUS;
        const isCorporateBonusChecked =
            walletType === WALLET_TYPES.CORPORATE_BONUS && bonusAmount;

        const isLoanDiscount =
            discount && data.value === PAYMENT_TYPES.LOAN.id;

        let checked = false;

        if (isBonus) {
            checked = isBonusChecked;
        } else if (isCorporateBonus) {
            checked = isCorporateBonusChecked;
        }
        if (isLoanDiscount) {
            checked = true;
        }

        if (
            this.state.orderDetails &&
            (data.value === this.state.orderDetails.paymentType ||
                data.value === this.state.orderDetails.additionalPaymentType) ||
            (this.state.orderDetails &&
                this.state.orderDetails.paymentType === 10 &&
                data.value === 8)
        ) {
            checked = true;
        }

        if (this.props.orderDetails.isNotEditable || paymentMethodsDisabled) {
            editable = false;
        }

        let name = `paymentType-${data.value}`;
        if (data.value === PAYMENT_TYPES.GIFT_CARD.id) {
            name = `paymentType-gift-card-${data.value}`;
        }
        if (data.value === PAYMENT_TYPES.BONUS.id) {
            name = `paymentType-bonus-${data.value}`;
        }

        if (isCorporateBonus && isBonusChecked) {
            editable = false;
        }
        if (isBonus && isCorporateBonusChecked) {
            editable = false;
        }

        if (
            data.value === PAYMENT_TYPES.OPERATIONAL_RISKS_COSTS.id &&
            this.role !== USER_ROLES.SUPER_ADMIN
        ) {
            editable = false;
        }

        return (
            <RadioGroup
                id={`paymentType-${index}`}
                disabled={
                    (data.disabled || !editable) &&
                    this.role !== USER_ROLES.SUPER_ADMIN
                }
                key={index}
                title={translator.translate(data.name)}
                value={data.value}
                checked={checked}
                onClick={(e) => {
                    if (
                        this.state.orderDetails.paymentType ===
                        PAYMENT_TYPES.GIFT_CARD.id
                    ) {
                        this.state.orderDetails.additionalPaymentType = Number(e.target.value);
                    } else {
                        this.state.orderDetails.paymentType = Number(e.target.value);
                        if (isBonus) {
                            this.state.orderDetails.walletType = WALLET_TYPES.BONUS;
                        } else if (isCorporateBonus) {
                            this.state.orderDetails.walletType = WALLET_TYPES.CORPORATE_BONUS;
                        }
                    }
                }}
                name={name}
                customClass="margin-to-right"
                customRadioClass="to-right"
            />
        );
    }

    renderPaymentType() {
        const additionalStyle = this.propertyWasChanged("paymentType")
            ? "was-changed"
            : "";
        return (
            <div className="display-flex padding" key="paymentType">
                <label className={`label-width ${additionalStyle}`}>
                    {translator.translate("_payment_method_")}:
                </label>
                <div className="my-custom-input margin-to-left">
                    {PAYMENT_TYPES.paymentMethods(this.state.orderDetails.paymentType).map(this.renderRadioGroup)}
                </div>
            </div>
        );
    }

    renderOrderNotifications() {
        return (
            <div className="display-flex padding" key="orderNotifications">
                <label className="label-width">
                    {translator.translate("_order_notifications_types_")}:
                </label>
                <div className="my-custom-input margin-to-left">
                    {NOTIFICATION_TYPES.types().map(
                        this.renderRadioGroupForOrderNotification,
                    )}
                </div>
            </div>
        );
    }

    renderRadioGroupForOrderNotification(data, index) {
        const callNotification =
            this.state.orderDetails &&
            this.state.orderDetails.customer &&
            this.state.orderDetails.customer.orderNotificationChannels;
        let checked;
        if (callNotification) {
            checked =
                data.value === NOTIFICATION_TYPES.EMAIL.id
                    ? true
                    : callNotification.includes(data.value);
        } else {
            checked = data.value === NOTIFICATION_TYPES.EMAIL.id ? true : false;
        }
        return (
            <RadioGroup
                id={`orderNotification-${index}`}
                disabled={true}
                key={index}
                title={translator.translate(data.name)}
                value={data.value}
                checked={checked}
                name={data.name}
                customClass="margin-to-right"
                customRadioClass="to-right"
            />
        );
    }

    dateValidation() {
        let shops = this.state.orderDetails.shops ? this.state.orderDetails.shops : [],
            readyTime,
            deliveryTime = this.getDeliveryTime();
        shops.forEach((item, i) => {
            readyTime = shops[i].readyTime;
        });

        const diffInMinutes = moment(deliveryTime).diff(
            moment(readyTime),
            "minutes",
        );
        this.setState({ invalidDate: diffInMinutes <= 15 });
    }

    getDeliveryTime() {
        let deliveryTime;
        if (
            "object" === typeof this.state.orderDetails.deliveryTime &&
            this.state.orderDetails.deliveryTime.length
        ) {
            deliveryTime =
                this.state.orderDetails.deliveryTime[
                this.state.orderDetails.deliveryTime.length - 1
                    ].date;
            deliveryTime = moment(deliveryTime);
        } else if (this.state.orderDetails.deliveryTime) {
            deliveryTime = this.state.orderDetails.deliveryTime
                ? moment(this.state.orderDetails.deliveryTime)
                : "";
        }
        return deliveryTime;
    }

    permitToEnter() {
        if (
            security.getUser().role === USER_ROLES.CALL_CENTER ||
            security.getUser().role === USER_ROLES.ADMIN
        ) {
            return false;
        }
        return true;
    }

    handleKeyPress(event) {
        if (this.permitToEnter()) {
            if (event.charCode === ENTER_KEY.keyCode && event.ctrlKey) {
                if (this.state.canSave) {
                    this.save();
                }
                return;
            }
        }
    }

    enableButton() {
        this.setState({ canSave: true });
    }

    disableButton() {
        this.setState({ canSave: false });
    }

    renderViewMode(data, index) {
        if (
            !this.state.orderDetails ||
            !rolesConf.order.canEdit(
                this.role,
                this.state.orderDetails.status,
                data.value,
            )
        ) {
            return null;
        }
        const isDisabled =
            data.value == ORDER_DETAILS_MODE.MODES.restore_mode &&
            this.state.orderDetails.paymentType == PAYMENT_TYPES.BY_CARD.id &&
            !!this.state.orderDetails.isRefunded;
        return (
            <RadioGroup
                id={`view-mode-${index}`}
                key={index}
                disabled={isDisabled}
                title={translator.translate(data.label)}
                value={data.value}
                checked={data.value === ORDER_DETAILS_MODE.MODES.edit_mode}
                onClick={(e) => {
                    this.setState({
                        orderMode: Number(e.target.value),
                        showPaymentDetails: false,
                    });
                }}
                name="view-mode"
                customClass="margin-to-right"
                customRadioClass="to-right"
            />
        );
    }

    getOrderAction({
                       isSuperAdmin,
                       isPickupOrder,
                       isDigitalOrder,
                       isDeliveredOrCanceled,
                   }) {
        const rules = [
            {
                condition: () =>
                    isSuperAdmin && !isDigitalOrder && !isPickupOrder,
                label: "_delivered_",
            },
            {
                condition: () => isDigitalOrder,
                label: "_sent_",
            },
            {
                condition: () =>
                    isPickupOrder && !isDeliveredOrCanceled,
                label: "_picked_up_",
            },
        ];

        const matched = rules.find(rule => rule.condition());

        return matched?.label || null;
    }

    renderPickedUpButton() {
        const { customer, orderId, status, isDigitalOrder, orderDetails } = this.state?.orderDetails;

        const isPickupOrder = Boolean(customer?.isPickUpOrder);

        const isDeliveredOrCanceled = [
            ORDER_STATUSES.DELIVERED.statusId,
            ORDER_STATUSES.CANCELED.statusId,
        ].includes(status);

        const HIDDEN_STATUSES = [
            ORDER_STATUSES.CANCELED.statusId,
            ORDER_STATUSES.DELIVERED.statusId,
        ];

        if (HIDDEN_STATUSES.includes(status)) {
            return null;
        }

        const isSuperAdmin = this.role === USER_ROLES.SUPER_ADMIN;
        const isOrderManager = this.role === USER_ROLES.ORDER_MANAGER;
        const isPrivileged = isSuperAdmin || isOrderManager;

        if (!isPrivileged) {
            return null;
        }

        const action = this.getOrderAction({
            isSuperAdmin,
            isPickupOrder,
            isDigitalOrder,
            isDeliveredOrCanceled,
        });

        if (!action) {
            return null;
        }

        const isAttachedDistributor = orderDetails?.distributor;

        return (
            <div className="pickup-button">
                <Button
                    bsStyle="success"
                    className="btn-xs"
                    disabled={!isAttachedDistributor && action === "_delivered_"}
                    onClick={() => {
                        if (action === "_delivered_") {
                            this.props.deliverOrder(orderId, () => this.hide());
                            return;
                        }
                        this.props.deliverPickUpOrder(orderId, () => this.hide());
                    }}
                >
                    {translator.translate(action)}
                </Button>
            </div>
        );
    }

    renderBookedOrderActions() {
        const {
            orderDetails: { isBookService, bookId, serviceStatus },
        } = this.props;

        if (
            (!bookId && !isBookService) ||
            (bookId && serviceStatus === 5) ||
            (isBookService && serviceStatus === 8)
        ) {
            return null;
        }

        const serviceStatuses =
            (isBookService && ORDER_SERVICE_STATUSES) ||
            (bookId && BOOKED_SERVICE_STATUSES);
        const actionOptions =
            (serviceStatuses &&
                serviceStatuses[serviceStatus] &&
                serviceStatuses[serviceStatus].actions.map((item) => ({
                    label: translator.translate(item.name),
                    value: item.id,
                }))) ||
            [];

        return (
            <div className="service-status-dropdown-container">
                <span>{translator.translate("_service_status_")}</span>
                <Select
                    placeholder={translator.translate("_choose_")}
                    className="service-status-dropdown"
                    onChange={(option) => {
                        this.setState({
                            orderDetails: {
                                ...this.state.orderDetails,
                                serviceStatus: option.value,
                            },
                        });
                    }}
                    options={actionOptions}
                />
            </div>
        );
    }

    renderSecondaryOrderCheckboxes() {
        const { bookId, status, salaryType } = this.state.orderDetails;

        if (
            bookId ||
            status === ORDER_STATUSES.CANCELED.statusId ||
            (status === ORDER_STATUSES.DELIVERED &&
                this.role !== USER_ROLES.SUPER_ADMIN) ||
            ![USER_ROLES.SUPER_ADMIN, USER_ROLES.MANAGER].includes(this.role)
        ) {
            return null;
        }

        return (
            <div
                style={{
                    display: "flex",
                    flex: "auto",
                    justifyContent: "flex-end",
                }}
            >
                <div className="display-flex padding">
                    <div>{translator.translate("_secondary_order_")}:</div>
                    <div className="margin-to-left">
                        <Checkbox
                            disabled={salaryType === SALARY_TYPES_ENUM.NONE}
                            className="margin-bottom order-margin"
                            checked={salaryType === SALARY_TYPES_ENUM.SECONDARY}
                            onChange={(e) => {
                                this.setState({
                                    orderDetails: {
                                        ...this.state.orderDetails,
                                        salaryType: e.target.checked
                                            ? SALARY_TYPES_ENUM.SECONDARY
                                            : SALARY_TYPES_ENUM.PRIMARY,
                                    },
                                });
                            }}
                        />
                    </div>
                </div>
                <div className="display-flex padding">
                    <div>
                        {translator.translate(
                            "_exclude_from_salary_calculation_",
                        )}
                        :
                    </div>
                    <div className="margin-to-left">
                        <Checkbox
                            disabled={
                                salaryType === SALARY_TYPES_ENUM.SECONDARY
                            }
                            className="margin-bottom order-margin"
                            checked={salaryType === SALARY_TYPES_ENUM.NONE}
                            onChange={(e) => {
                                this.setState({
                                    orderDetails: {
                                        ...this.state.orderDetails,
                                        salaryType: e.target.checked
                                            ? SALARY_TYPES_ENUM.NONE
                                            : SALARY_TYPES_ENUM.PRIMARY,
                                    },
                                });
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderCancelReasons(data, index) {
        return (
            <div key={index} className={"radio-padding"}>
                <RadioGroup
                    id={`cancel-reasons-${index}`}
                    title={translator.translate(data.label)}
                    value={data.value}
                    checked={
                        data.value === CANCEL_REASONS.CUSTOMER_DUPLICATE.id
                    }
                    onClick={(e) => {
                        this.setState({
                            isOtherReason:
                                Number(e.target.value) ===
                                CANCEL_REASONS.OTHER.id,
                            cancelReason: Number(e.target.value),
                        });
                    }}
                    name="cancel-reasons"
                    customClass="margin-to-right"
                    customRadioClass="to-right"
                />
                {this.renderOtherReasonInput(data.value)}
            </div>
        );
    }

    renderOtherReasonInput(value) {
        if (value === CANCEL_REASONS.OTHER.id && this.state.isOtherReason) {
            return (
                <textarea
                    type="text"
                    rows="3"
                    value={this.state.comment}
                    onChange={(e) => {
                        this.setState({ comment: e.target.value });
                    }}
                    className={"form-control default-font other-reason"}
                />
            );
        }
        return null;
    }

    onToggle(toggleActive) {
        const writtenCodesCount = this.state.orderDetails.giftCardCodes
            ? this.state.orderDetails.giftCardCodes.length
            : 0;
        if (writtenCodesCount === this.state.giftCardsCount) {
            this.setState({ toggleActive });
            if (toggleActive) {
                this.state.orderDetails.status = ORDER_STATUSES.NEW.statusId;
            } else {
                this.state.orderDetails.status = ORDER_STATUSES.DRAFT.statusId;
            }
        }
    }

    renderStatus() {
        const editable = rolesConf.order.canEdit(
                this.role,
                this.state.orderDetails.status,
                this.state.orderMode,
                "status",
            ),
            role = security.getUser().role,
            isOrderManager = USER_ROLES.ORDER_MANAGER === role,
            isDraft =
                this.props.orderDetails.status ===
                ORDER_STATUSES.DRAFT.statusId;
        if (!isOrderManager || !isDraft) {
            return null;
        }
        return (
            <ToggleWithLabel
                disabled={!editable}
                onToggle={this.onToggle.bind(this)}
                active={this.state.toggleActive}
                onText={ORDER_STATUSES.NEW.name}
                offText={ORDER_STATUSES.DRAFT.name}
                offClassName="danger"
                label={"_status_"}
                htmlFor={"toggle"}
                style={{ add: true }}
            />
        );
    }

    openMap() {
        this.setState({
            showMap: true,
            addressKey: this.state.orderDetails.receiver.address,
            openAutoCompleteSelect: true,
            center: this.state.orderDetails.receiver.location || null,
        });
    }

    hideModal() {
        this.setState({ showMap: false });
    }

    saveAddress(location, address) {
        if (location && location.lat && location.lng) {
            this.props.reverseGeocode(location.lat, location.lng, (result) => {
                const finalAddress = result && result.data && result.data.length > 0 ? result.data[0].address : address;
                this.state.orderDetails.receiver.location = location;
                this.state.orderDetails.receiver.address = finalAddress;
                this.setState({ showMap: false, center: defaultViewport });
                this.save();
            });
        } else {
            this.state.orderDetails.receiver.location = location;
            this.state.orderDetails.receiver.address = address;
            this.setState({ showMap: false, center: defaultViewport });
            this.save();
        }
    }

    renderMap() {
        return (
            <ReceiverMap
                show={this.state.showMap}
                dialogClassName="large-modal"
                onHide={this.hideModal.bind(this)}
                onKeyPress={this.handleKeyPress}
                addressKey={this.state.addressKey}
                name={"search-address"}
                viewport={{ center: this.state.center, zoom: this.state.zoom }}
                saveAddress={this.saveAddress.bind(this)}
            />
        );
    }

    renderDateTime(item, index) {
        let disabled =
            item.disabled ||
            !rolesConf.order.canEdit(
                this.role,
                this.state.orderDetails.status,
                this.state.orderMode,
                item.id,
            ) ||
            this.props.orderDetails.isNotEditable;
        let deliveryTime = this.getDeliveryTime();
        let reqStyle = this.state.invalidDate ? "req-style" : "";
        return (
            <div className={"display-flex padding"} key={index}>
                <label htmlFor={item.htmlFor} className={"label-width"}>
                    {translator.translate(item.label)}:
                </label>
                <Datetime
                    value={deliveryTime}
                    onChange={(e) => {
                        let deliveryTime =
                            typeof e === "string"
                                ? e
                                : e.format("DD/MM/YYYY HH:mm");
                        this.setState({ canSave: deliveryTime.length === 16 });
                        if ("function" === typeof e.format) {
                            this.state.orderDetails.deliveryTime = e;
                            this.setState({ deliveryTime: e });
                            this.dateValidation();
                        }
                    }}
                    dateFormat={"DD/MM/YYYY"}
                    timeFormat={"HH:mm"}
                    viewMode={"time"}
                    timeConstraints={{
                        minutes: {
                            step: 5,
                        },
                    }}
                    inputProps={{
                        onClick: (e) => {
                            if (!e.target.value) {
                                this.setState({ deliveryTime: moment() });
                            }
                        },
                        className: `form-control ${reqStyle}`,
                        disabled,
                    }}
                    className="default-font my-custom-input"
                    key={index}
                />
            </div>
        );
    }

    handleChangeValue = (key, value) => {
        this.setState((prevState) => {
            let orderDetails = { ...prevState.orderDetails };

            if (Array.isArray(key)) {
                let obj = orderDetails;
                key.forEach((k, i) => {
                    if (i === key.length - 1) {
                        obj[k] = value;
                    } else {
                        obj = obj[k] = obj[k] || {};
                    }
                });
            } else {
                orderDetails[key] = value;
            }

            return { orderDetails };
        });
    };

    renderInputGroup(item) {
        return (
            (this.state.orderDetails && this.state.orderDetails.isDigitalOrder) ?
                <div key={item.htmlFor} className="display-flex align-center">
                    <label htmlFor={item.htmlFor} className={"label-width"}>
                        {translator.translate(item.label)}
                    </label>
                    <div className="my-custom-input">
                        {item.inputs.map((input, idx) => {
                            const value = this.getValue(input.key, input.format);
                            let disabled =
                                !rolesConf.order.canEdit(
                                    this.role,
                                    this.state.orderDetails.status,
                                    this.state.orderMode,
                                    input.key,
                                ) ||
                                this.props.orderDetails.isNotEditable;

                            const options = {
                                ...input,
                                value,
                                disabled,
                                onChange: (e) => {
                                    const newValue = e.target.value;
                                    this.handleChangeValue(input.key, newValue);
                                },
                            };

                            // Remove key from options to avoid passing it via spread
                            const { key, ...optionsWithoutKey } = options;

                            return (
                                <FormInput
                                    key={input.id}
                                    {...optionsWithoutKey}
                                />
                            );
                        })}
                    </div>
                </div>
                : null
        );
    }

    renderInputWithLabel(item, index) {
        if (item && item.id === "deliveryPrice") {
            return this.renderDeliveryPriceField(item, index);
        }
        const options = this.getOptions(item, index);

        const showOpenMapButton =
            item.id === "address" &&
            [
                USER_ROLES.MANAGER,
                USER_ROLES.ADMIN,
                USER_ROLES.SUPER_ADMIN,
                USER_ROLES.ORDER_MANAGER,
            ].includes(this.role);

        const { key, ...optionsWithoutKey } = options;
        const uniqueKey = `${item.id}-${index}`;

        return (
            <div key={uniqueKey} style={{ display: options.display || "block" }}>
                {item.id === "receiverPhone" && (
                    <Button
                        bsStyle="success"
                        className="btn-xs phone-button"
                        onClick={this.handlePhoneClick.bind(
                            this,
                            options.value,
                        )}
                    >
                        <span className="glyphicon glyphicon-earphone" />
                    </Button>
                )}
                {item.id === "address" ? (
                    this.renderAddressInputWithLabel(
                        item,
                        index,
                        optionsWithoutKey,
                        showOpenMapButton,
                    )
                ) : (
                    <FormInput
                        key={index}
                        {...optionsWithoutKey}
                        inputStyle={
                            item.id === "receiverPhone" || showOpenMapButton
                                ? "input-with-margin"
                                : null
                        }
                    />
                )}
            </div>
        );
    }

    renderDeliveryPriceField(item, index) {
        const baseOptions = this.getOptions(item, index);
        const baseCanEdit =
            !item.disabled &&
            rolesConf.order.canEdit(
                this.role,
                this.state.orderDetails.status,
                this.state.orderMode,
                item.id,
            ) &&
            !this.props.orderDetails.isNotEditable;

        // Roles that cannot edit the amount at all keep the legacy read-only
        // rendering without the reason gate, but history stays visible.
        if (!baseCanEdit) {
            const { key, ...optionsWithoutKey } = baseOptions;
            const uniqueKey = `${item.id}-${index}`;
            return (
                <div key={uniqueKey} style={{ display: baseOptions.display || "block" }}>
                    <FormInput key={index} {...optionsWithoutKey} />
                    {this.renderDeliveryPriceChangeHistory()}
                </div>
            );
        }

        // Super Admin is exempt from the gate: free editing, no reason UI.
        if (this.role === USER_ROLES.SUPER_ADMIN) {
            const { key, ...optionsWithoutKey } = baseOptions;
            const uniqueKey = `${item.id}-${index}`;
            return (
                <div key={uniqueKey} style={{ display: baseOptions.display || "block" }}>
                    <FormInput key={index} {...optionsWithoutKey} />
                    {this.renderDeliveryPriceChangeHistory()}
                </div>
            );
        }

        const {
            deliveryPriceReason,
            deliveryPriceOtherDraft,
            deliveryPriceOtherSaved,
            isDeliveryPriceUnlocked,
        } = this.state;
        const isOtherSelected = this.isDeliveryPriceOtherReason(deliveryPriceReason);
        const gatedDisabled = !isDeliveryPriceUnlocked;
        const draftLength = (deliveryPriceOtherDraft || "").length;

        const { key, ...restWithoutKey } = baseOptions;
        const amountOptions = {
            ...restWithoutKey,
            disabled: gatedDisabled,
        };
        if (!gatedDisabled) {
            amountOptions.onChange = (e) => {
                this.setValue(item.key, e.target.value);
                this.setState({});
            };
        } else {
            delete amountOptions.onChange;
        }

        const uniqueKey = `${item.id}-${index}`;

        return (
            <div key={uniqueKey} style={{ display: baseOptions.display || "block" }}>
                <FormInput key={`${index}-amount`} {...amountOptions} />
                <div className="display-flex padding" key={`${index}-reason`}>
                    <label htmlFor="deliveryPriceReason" className="label-width">
                        {DELIVERY_PRICE_REASON_LABEL}
                    </label>
                    <div className="my-custom-input margin-to-left">
                        <select
                            id="deliveryPriceReason"
                            value={deliveryPriceReason}
                            onChange={this.handleDeliveryPriceReasonChange}
                            className="form-control default-font"
                        >
                            <option value="">
                                {translator.translate("_choose_")}
                            </option>
                            {DELIVERY_PRICE_CHANGE_REASONS.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                            ))}
                        </select>
                        {isOtherSelected ? (
                            <div style={{ marginTop: "8px" }}>
                                <textarea
                                    rows="3"
                                    maxLength={DELIVERY_PRICE_OTHER_MAX_LENGTH}
                                    value={deliveryPriceOtherDraft}
                                    onChange={this.handleDeliveryPriceOtherDraftChange}
                                    className="form-control default-font"
                                />
                                <div className="default-font" style={{ marginTop: "4px" }}>
                                    {draftLength}/{DELIVERY_PRICE_OTHER_MAX_LENGTH}
                                </div>
                                <Button
                                    bsStyle="primary"
                                    className="btn-xs"
                                    style={{ marginTop: "4px" }}
                                    disabled={!(deliveryPriceOtherDraft || "").trim()}
                                    onClick={this.handleDeliveryPriceOtherSave}
                                >
                                    {translator.translate("_save_")}
                                </Button>
                                {deliveryPriceOtherSaved && isDeliveryPriceUnlocked ? (
                                    <div
                                        className="default-font"
                                        style={{ marginTop: "4px", color: "#5cb85c" }}
                                    >
                                        {translator.translate("_save_")}: {deliveryPriceOtherSaved}
                                    </div>
                                ) : null}
                            </div>
                        ) : null}
                    </div>
                </div>
                {this.renderDeliveryPriceChangeHistory()}
            </div>
        );
    }

    handlePhoneClick(phone) {
        redirectToOkTellTab(OK_TELL_URL, phone, "_blank");
    }

    getNotes() {
        let notes = "";
        if (
            this.props.orderDetails.ticket &&
            this.props.orderDetails.ticket.source
        ) {
            try {
                (this.props.orderDetails.ticket.source || []).map((item) => {
                    if (item.note) {
                        notes += "\n" + item.note;
                    }
                    return item;
                });
            } catch (error) {
                console.error("Error in ticket.source.map:", error);
                console.error("ticket.source:", this.props.orderDetails.ticket?.source);
            }
        }
        return notes;
    }

    getDistributorRejectionReasons() {
        let reason = "";
        if (this.props.orderDetails.distributorRejectionReasons) {
            this.props.orderDetails.distributorRejectionReasons.forEach(
                (item) => {
                    reason += `${
                        getDistributor(
                            item.distributor,
                            this.props.distributors,
                        ).name
                    } - ${item.reason} - ${moment(item.date).format(
                        "DD/MM/YYYY HH:mm",
                    )} \n`;
                },
            );
        }
        return reason;
    }

    getOptions(item, index) {
        let disabled =
            item.disabled ||
            !rolesConf.order.canEdit(
                this.role,
                this.state.orderDetails.status,
                this.state.orderMode,
                item.id,
            ) ||
            this.props.orderDetails.isNotEditable;
        const additionalStyle = this.propertyWasChanged(item.key)
            ? "was-changed"
            : "";
        let value = this.getValue(item.key, item.format);

        if (item.key === "distributorRejectionReasons") {
            value = this.getDistributorRejectionReasons();
        } else if (item.key === "cacheIn") {
            value =
                (this.state.orderDetails.shops &&
                    this.state.orderDetails.shops[0].cacheIn) ||
                "";
        } else if (item.key === "voucherInfo") {
            value =
                (this.state.orderDetails.discount
                    &&
                    this.state.orderDetails.discount.totalAmount) ||
                "";
        }
        const options = {
            ...item,
            disabled,
            additionalStyle,
            value,
            key: index,
        };
        delete options.elementType;
        delete options.format;
        if (!options.disabled) {
            options.onChange = (e) => {
                this.setValue(item.key, e.target.value);
                this.setState({});
            };
        }
        return options;
    }

    onDelete(i) {
        const { suggestions } = this.state;
        const deleted = this.state.orderDetails.giftCardCodes.splice(i, 1)[0];
        if (deleted) {
            delete deleted._id;
            suggestions.push({ id: deleted.id, name: deleted.code });
            this.setState({ suggestions });
        }
    }

    onAddition(tag) {
        let { suggestions } = this.state;
        suggestions = suggestions.filter((item) => item.id !== tag.id);
        this.state.orderDetails.giftCardCodes.push({ id: tag.id, code: tag.name });
        this.setState({ suggestions });
    }

    renderTagComponent({ tag, removeButtonText, onDelete }) {
        return (
            <Label type="button" title={removeButtonText}>
                {tag.code}
                <button
                    type="button"
                    className="left-distance"
                    onClick={onDelete}
                >
                    X
                </button>
            </Label>
        );
    }

    renderSuggestionComponent({ item, query }) {
        return (
            <span
                id={item.id}
                key={item.id}
                className={item.name === query ? "match" : "no-match"}
            >
                {item.name}
            </span>
        );
    }

    renderTextareaWithLabel(item, index) {
        if (item.key[0] === "giftCardCodes") {
            const writtenCodesCount = this.state.orderDetails.giftCardCodes
                ? this.state.orderDetails.giftCardCodes.length
                : 0;
            if (
                this.state.giftCardsCount &&
                (this.role === USER_ROLES.ORDER_MANAGER ||
                    this.role === USER_ROLES.SUPER_ADMIN ||
                    this.role === USER_ROLES.ADMIN)
            ) {
                return (
                    <div
                        key="giftCardCodes"
                        className={"display-flex align-center padding"}
                    >
                        <label htmlFor={item.htmlFor} className={"label-width"}>
                            {translator.translate(item.label)}
                        </label>
                        <div className={"my-custom-input"}>
                            <div className={"gift-cards-code-area padding"}>
                                <ReactTags
                                    disabled={true}
                                    tags={this.state.orderDetails.giftCardCodes}
                                    suggestions={this.state.suggestions}
                                    onDelete={this.onDelete.bind(this)}
                                    onAddition={this.onAddition.bind(this)}
                                    tagComponent={this.renderTagComponent.bind(
                                        this,
                                    )}
                                    suggestionComponent={this.renderSuggestionComponent.bind(
                                        this,
                                    )}
                                    placeholderText={translator.translate("_gift_card_")}
                                />
                            </div>
                            <div
                                className={`gift-cards-counter ${
                                    writtenCodesCount ===
                                    this.state.giftCardsCount
                                        ? "green-color"
                                        : "text-red"
                                }`}
                            >
                                {writtenCodesCount}/{this.state.giftCardsCount}
                            </div>
                        </div>
                    </div>
                );
            } else return null;
        } else {
            const options = this.getOptions(item, index);
            const { key, ...optionsWithoutKey } = options;
            return <TextareaWithLabel key={index} {...optionsWithoutKey} />;
        }
    }

    renderCheckboxWithLabel(item, index) {
        const canEdit = rolesConf.order.canEdit(
            this.role,
            this.state.orderDetails.status,
            this.state.orderMode,
            item.key,
        );
        return (
            <div className="display-flex padding" key={index}>
                <label className={`label-width`}>
                    {translator.translate(item.label)}:
                </label>
                <div className="my-custom-input margin-to-left">
                    <Checkbox
                        disabled={!canEdit}
                        className="margin-bottom order-margin"
                        checked={this.state.orderDetails[item.key]}
                        onChange={(e) => {
                            this.state.orderDetails[item.key] = e.target.checked;
                            this.setState({});
                        }}
                    />
                </div>
            </div>
        );
    }

    renderInputs() {
        try {
            return (EditableFields || []).map((item, index) => {
                switch (item.elementType) {
                    case "RadioGroup":
                        return this.renderPaymentType(index);
                    case "TextareaWithLabel":
                        return this.renderTextareaWithLabel(item, index);
                    case "InputWithLabel":
                        return this.renderInputWithLabel(item, index);
                    case "InputsGroup":
                        return this.renderInputGroup(item);
                    case "DateTime":
                        return this.renderDateTime(item, index);
                    case "DistributorList":
                        return this.renderDistributor();
                    case "CheckBox":
                        return this.renderCheckboxWithLabel(item, index);
                    case "RadioGroupNotification":
                        return this.renderOrderNotifications(index);
                    default:
                        return null;
                }
            });
        } catch (error) {
            console.error("Error in renderInputs EditableFields.map:", error);
            return null;
        }
    }

    renderModalBody() {
        const { orderMode, showPaymentDetails } = this.state;

        if (orderMode === ORDER_DETAILS_MODE.MODES.restore_mode) {
            return null;
        }

        if (showPaymentDetails) {
            return (
                <div style={{ overflow: "auto" }}>
                    <PaymentDetails
                        paymentDetails={
                            this.props.orderDetails.groupOrderDetails
                        }
                        voucherDetails={this.props.orderDetails.discount}
                        posTransactions={this.props.orderDetails.posTransactions || []}
                        tipTransactions={this.props.orderDetails.tip}
                        orderDetails={this.props.orderDetails}
                    />
                </div>
            );
        }

        if (this.state.orderMode === ORDER_DETAILS_MODE.MODES.cancel_mode) {
            return CANCEL_REASONS.cancelReasons().map((reason, index) =>
                this.renderCancelReasons(reason, index),
            );
        }

        return (
            <div>
                {this.renderSelectShopsModal()}
                {this.renderStatus()}
                {this.renderMap()}
                {this.renderShops()}
                {this.renderInputs()}
            </div>
        );
    }

    render() {
        const {
            orderDetails: { show, customer, groupOrderDetails },
        } = this.props;
        return (
            <Modal
                dialogClassName="large-modal"
                show={show}
                onHide={this.hide.bind(this)}
                onKeyPress={this.handleKeyPress}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {translator.translate("_order_details_")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="scrollable modal-possition">
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            fontWeight: 700,
                            width: "100%",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            {ORDER_DETAILS_MODE.DATA.map(this.renderViewMode)}
                            {!!(
                                customer
                            ) && (
                                <div
                                    style={{ marginRight: "10px" }}
                                    onClick={() =>
                                        this.setState({
                                            showPaymentDetails: true,
                                            shops: this.state.orderDetails.shops,

                                        })
                                    }
                                >
                                    {translator.translate(
                                        "_group_order_payment_details",
                                    )}
                                </div>
                            )}
                            {this.renderPickedUpButton()}
                            {this.renderBookedOrderActions()}
                        </div>
                        {this.renderSecondaryOrderCheckboxes()}
                    </div>
                    <Formsy
                        onValid={this.enableButton}
                        onInvalid={this.disableButton}
                    >
                        {this.renderModalBody()}
                    </Formsy>
                </Modal.Body>
                {this.renderFooter()}
            </Modal>
        );
    }
}

const getLocationSelectionInConfigs = (confs) => {
    if (!confs || !Object.keys(confs).length) {
        return false;
    }
    return confs.locationSelection === "true";
};

const getDispatchForOrder = (state) => {
    if (state.configs.dispatching) {
        let suggestObj = state.configs.dispatching.find((e) => {
            return e.steps.find((elem) => {
                return !!(
                    elem.where.id && elem.where.id == state.orderDetails.orderId
                );
            });
        });
        if (suggestObj) {
            return suggestObj.courier.id;
        } else {
            return null;
        }
    } else {
        return null;
    }
};

let mapStateToProps = (state) => {

    return {
        orderDetails: state.orderDetails,
        distributors: state.distributors,
        newDistributors: state.newDistributors || [],
        restaurants: state.restaurants,
        giftCards: state.giftCards.giftCards,
        locationSelection: getLocationSelectionInConfigs(state.configs),
        dispatchResponse: getDispatchForOrder(state),
    };
};

export default connect(mapStateToProps, {
    updateOrderByApi,
    assignDistributor,
    closeOrderDetails,
    cancelOrderByApi,
    cancelBookedOrderByApi,
    restoreOrderByApi,
    updateProduct,
    sendToPartner,
    updateShopState,
    searchAddress,
    reverseGeocode,
    divideOrder,
    getShopsForMergeOrder,
    divideOrderAuto,
    deliverOrder,
    deliverPickUpOrder,
    openOrderDetails,
    getRestaurantsByIDs,
    getNewDistributorList,
})(OrderDetails);
